var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailureTransaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 386.209,
    height: 376.884,
    viewBox: "0 0 386.209 376.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7753",
    "data-name": "Group 7753",
    transform: "translate(-564.894 -97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7308",
    "data-name": "Group 7308",
    transform: "translate(623.979 293.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7286",
    "data-name": "Group 7286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7285",
    "data-name": "Group 7285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11940",
    "data-name": "Path 11940",
    d: "M105.208,275.049s-7.418,1.961-1.176,17.981,10.865,24.1,10.865,24.1,1.021,3.676-2.01,3.921-9.485-1.454-11.176,2.059c-1.756,3.643.629,7.483,5.882,11.167s16.453,12.18,17.466,12.956c.988.76,1.887,2.508-.155,3.014s-16.935.556-16.486,7.622,16.763,14.933,18.528,15.824,2.124,1.716,1.879,2.712-5.261.539-9.5.727-9.117,1.152-8.512,5.2,9.795,13.373,33.9,18.209l11.323,1.511,7.148-8.97c14.125-20.137,14.345-33.224,11.984-36.574s-6.56-.678-9.754,2.1-6.511,6.568-7.377,6.021-1.176-1.389-.515-3.259,7.042-18.814,2.492-24.238-15.375,4.812-17.2,5.849-2.385-.841-2.189-2.075c.2-1.258,2.451-15.138,3.709-21.428s.335-10.718-3.447-12.139c-3.643-1.372-7.14,4.313-9.509,6.217s-4.158-1.454-4.158-1.454-2.23-9.043-8.757-24.941-13.406-12.074-13.406-12.074",
    transform: "translate(-101.141 -274.686)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7289",
    "data-name": "Group 7289",
    transform: "translate(9.623 14.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7288",
    "data-name": "Group 7288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7287",
    "data-name": "Group 7287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11941",
    "data-name": "Path 11941",
    d: "M158.513,408.071c-4.746-11.7-12.842-32.62-19.884-50.551s-13.43-34.147-18.119-45.862c-2.345-5.849-4.248-10.579-5.571-13.871-.654-1.626-1.16-2.9-1.511-3.774-.163-.425-.294-.752-.384-.988-.082-.221-.123-.343-.123-.343s.057.106.155.327.237.555.417.972c.368.874.89,2.132,1.577,3.75,1.364,3.26,3.3,7.981,5.669,13.831,4.746,11.7,11.176,27.906,18.209,45.83s15.1,38.869,19.786,50.584",
    transform: "translate(-112.92 -292.68)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7292",
    "data-name": "Group 7292",
    transform: "translate(9.5 51.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7291",
    "data-name": "Group 7291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7290",
    "data-name": "Group 7290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11942",
    "data-name": "Path 11942",
    d: "M112.77,337.309a3.75,3.75,0,0,1,.768.3c.49.212,1.185.539,2.034.956,1.707.825,4.036,2.034,6.584,3.407,2.508,1.364,4.771,2.6,6.5,3.545.784.425,1.446.776,1.977,1.062a4.131,4.131,0,0,1,.711.417,3.484,3.484,0,0,1-.776-.294c-.49-.212-1.185-.539-2.034-.964-1.7-.85-4.011-2.083-6.56-3.456l-6.527-3.5-1.985-1.054A3.257,3.257,0,0,1,112.77,337.309Z",
    transform: "translate(-112.769 -337.306)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7295",
    "data-name": "Group 7295",
    transform: "translate(28.924 38.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7294",
    "data-name": "Group 7294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7293",
    "data-name": "Group 7293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11943",
    "data-name": "Path 11943",
    d: "M136.549,343.489c-.09-.041,2.181-4.951,5.073-10.963s5.3-10.857,5.392-10.816-2.181,4.951-5.073,10.963S136.639,343.538,136.549,343.489Z",
    transform: "translate(-136.547 -321.71)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7298",
    "data-name": "Group 7298",
    transform: "translate(38.492 71.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7297",
    "data-name": "Group 7297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7296",
    "data-name": "Group 7296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11944",
    "data-name": "Path 11944",
    d: "M148.26,378.977a3.7,3.7,0,0,1,.531-.654c.408-.457.923-1.029,1.528-1.707,1.291-1.438,3.064-3.439,4.942-5.719s3.513-4.387,4.681-5.931c.547-.727,1.013-1.34,1.389-1.822a3.628,3.628,0,0,1,.539-.645,3.841,3.841,0,0,1-.433.727c-.294.457-.735,1.1-1.3,1.9-1.119,1.585-2.72,3.725-4.607,6.013s-3.693,4.264-5.024,5.661c-.67.694-1.225,1.258-1.618,1.634A3.373,3.373,0,0,1,148.26,378.977Z",
    transform: "translate(-148.259 -362.499)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7301",
    "data-name": "Group 7301",
    transform: "translate(19.124 83.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7300",
    "data-name": "Group 7300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7299",
    "data-name": "Group 7299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11945",
    "data-name": "Path 11945",
    d: "M124.55,377.4a3.2,3.2,0,0,1,.776.09c.564.106,1.266.229,2.083.376,1.756.335,4.183.817,6.854,1.381s5.089,1.086,6.829,1.479c.809.2,1.5.359,2.059.49a3.1,3.1,0,0,1,.743.229,3.2,3.2,0,0,1-.776-.09c-.564-.106-1.266-.229-2.083-.376-1.756-.335-4.183-.817-6.854-1.381s-5.089-1.087-6.83-1.479c-.809-.2-1.5-.359-2.059-.49A3.092,3.092,0,0,1,124.55,377.4Z",
    transform: "translate(-124.55 -377.39)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7304",
    "data-name": "Group 7304",
    transform: "translate(24.426 109.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7303",
    "data-name": "Group 7303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7302",
    "data-name": "Group 7302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11946",
    "data-name": "Path 11946",
    d: "M131.04,408.989a5.673,5.673,0,0,1,.988.123c.694.122,1.593.286,2.671.474,2.255.417,5.367,1.013,8.8,1.7s6.535,1.323,8.774,1.8c1.07.237,1.961.433,2.655.588a5.839,5.839,0,0,1,.964.261,5.678,5.678,0,0,1-.989-.123c-.694-.122-1.593-.286-2.671-.474-2.255-.417-5.367-1.013-8.8-1.7s-6.535-1.323-8.774-1.8c-1.07-.237-1.961-.433-2.655-.588A5.837,5.837,0,0,1,131.04,408.989Z",
    transform: "translate(-131.04 -408.982)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7307",
    "data-name": "Group 7307",
    transform: "translate(48.72 93.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7306",
    "data-name": "Group 7306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7305",
    "data-name": "Group 7305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11947",
    "data-name": "Path 11947",
    d: "M160.78,409.9a6.052,6.052,0,0,1,.654-.85c.482-.58,1.111-1.323,1.863-2.23,1.568-1.887,3.733-4.5,6.029-7.45s4.322-5.678,5.768-7.655c.694-.956,1.274-1.74,1.716-2.345a7.312,7.312,0,0,1,.662-.841,6.652,6.652,0,0,1-.547.915c-.376.58-.923,1.405-1.626,2.418-1.4,2.026-3.382,4.779-5.694,7.728s-4.5,5.555-6.119,7.4c-.809.923-1.479,1.658-1.952,2.157A6.282,6.282,0,0,1,160.78,409.9Z",
    transform: "translate(-160.779 -388.53)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7322",
    "data-name": "Group 7322",
    transform: "translate(762.912 369.205) rotate(-42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7321",
    "data-name": "Group 7321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7320",
    "data-name": "Group 7320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7319",
    "data-name": "Group 7319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7309",
    "data-name": "Group 7309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11948",
    "data-name": "Path 11948",
    d: "M366.63,430.79l-56.719-93.881A6.166,6.166,0,0,1,312,328.445l57.356-34.654a6.166,6.166,0,0,1,8.463,2.091l56.719,93.881a6.162,6.162,0,0,1-2.083,8.455L375.1,432.873A6.172,6.172,0,0,1,366.63,430.79Z",
    transform: "translate(-309.024 -292.904)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7310",
    "data-name": "Group 7310",
    transform: "translate(90.835 80.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11949",
    "data-name": "Path 11949",
    d: "M432.988,407.269a8.419,8.419,0,1,1,2.851-11.559A8.422,8.422,0,0,1,432.988,407.269Z",
    transform: "translate(-420.215 -391.645)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7311",
    "data-name": "Group 7311",
    transform: "translate(95.672 88.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11950",
    "data-name": "Path 11950",
    d: "M434.978,419.433a9.067,9.067,0,0,1-2.132-.261,8.78,8.78,0,1,1,2.132.261Zm-.025-16.845a8.011,8.011,0,0,0-6.838,12.156,8.021,8.021,0,0,0,11,2.712h0a8.015,8.015,0,0,0-2.222-14.639A8.36,8.36,0,0,0,434.954,402.588Z",
    transform: "translate(-426.136 -401.776)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7312",
    "data-name": "Group 7312",
    transform: "translate(21.637 31.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11951",
    "data-name": "Path 11951",
    d: "M341.662,333.182l-5.792,3.5-.359-.6,5.269-3.178-.825-1.364.531-.319Z",
    transform: "translate(-335.51 -331.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11952",
    "data-name": "Path 11952",
    d: "M340.33,343.25l-.531.319L337.34,339.5l.425-.253,3.815.98a2.24,2.24,0,0,0,1.9-.09c.67-.408.8-1.127.261-2.01a2.294,2.294,0,0,0-1.6-1.193l.106-.645a3.026,3.026,0,0,1,2.067,1.552c.711,1.176.564,2.279-.409,2.867a2.779,2.779,0,0,1-2.385.147l-3.129-.8Z",
    transform: "translate(-335.845 -332.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11953",
    "data-name": "Path 11953",
    d: "M346.051,350.365l-.7-1.16-1.519.923-.359-.6,1.528-.923-1.977-3.268.433-.261,5.694.752.4.662-5.531-.7,1.52,2.516,1.34-.809.351.58-1.34.809.7,1.16Z",
    transform: "translate(-336.885 -333.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11954",
    "data-name": "Path 11954",
    d: "M352.621,361.236l-.7-1.16L350.4,361l-.359-.6,1.528-.923-1.977-3.268.433-.261,5.694.752.4.662-5.531-.7,1.519,2.516,1.34-.809.351.58-1.34.809.7,1.16Z",
    transform: "translate(-338.088 -335.755)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11955",
    "data-name": "Path 11955",
    d: "M356.461,367.154c-.988.6-2.173.376-3.031-1.046a3.463,3.463,0,0,1-.506-2.524h.645a2.9,2.9,0,0,0,.408,2.181c.6.988,1.389,1.217,2.091.792.743-.449.931-1.193.041-2.671l-.743-1.234,3.088-1.462,1.92,3.17-.531.319-1.6-2.647-1.969.915.449.743C357.777,365.454,357.491,366.533,356.461,367.154Z",
    transform: "translate(-338.685 -336.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11956",
    "data-name": "Path 11956",
    d: "M360.775,374.2a2.108,2.108,0,0,1-2.974-.907c-.931-1.536-.368-3.023,1.462-4.126,1.969-1.193,3.643-.735,4.6.842a3.023,3.023,0,0,1,.515,1.568l-.629.049a2.393,2.393,0,0,0-.409-1.291c-.752-1.25-2.042-1.569-3.619-.621-.131.082-.294.188-.458.31a2.172,2.172,0,0,1,2.067,1.168A2.05,2.05,0,0,1,360.775,374.2Zm-.376-.572a1.49,1.49,0,0,0,.368-2.214,1.49,1.49,0,1,0-2.483,1.552A1.49,1.49,0,0,0,360.4,373.629Z",
    transform: "translate(-339.51 -338.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11957",
    "data-name": "Path 11957",
    d: "M366.521,383.8c-.972.588-2.14.335-2.982-1.07a3.491,3.491,0,0,1-.515-2.533h.645a2.977,2.977,0,0,0,.417,2.206c.58.964,1.348,1.217,2.067.784.694-.417.858-1.185.2-2.263l-.253-.417.441-.261,2.982.392-1.789-2.966.531-.319,2.255,3.725-.425.253-3.055-.392C367.73,382.219,367.452,383.232,366.521,383.8Z",
    transform: "translate(-340.534 -339.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11958",
    "data-name": "Path 11958",
    d: "M370.935,391.031a2.108,2.108,0,0,1-2.974-.907c-.931-1.536-.368-3.023,1.462-4.125,1.969-1.193,3.644-.735,4.6.841a3.023,3.023,0,0,1,.515,1.569l-.629.049a2.393,2.393,0,0,0-.409-1.291c-.752-1.25-2.042-1.568-3.619-.621-.131.082-.294.188-.457.31a2.165,2.165,0,0,1,2.067,1.168A2.045,2.045,0,0,1,370.935,391.031Zm-.368-.58a1.489,1.489,0,0,0,.368-2.214,1.49,1.49,0,1,0-2.483,1.552A1.483,1.483,0,0,0,370.567,390.451Z",
    transform: "translate(-341.37 -341.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11959",
    "data-name": "Path 11959",
    d: "M378.9,394.874l-.425.253-6.838.817-.392-.645,6.707-.8-1.805-2.982-1.087.653-.351-.588,1.618-.972Z",
    transform: "translate(-342.053 -342.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11960",
    "data-name": "Path 11960",
    d: "M385.035,405.014l-.425.253-6.838.817-.392-.645,6.707-.8-1.8-2.982-1.087.654-.351-.588,1.618-.972Z",
    transform: "translate(-343.175 -343.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11961",
    "data-name": "Path 11961",
    d: "M385.049,414.668c-1.029.621-2.189.139-3.023-1.25s-.711-2.622.31-3.243a1.7,1.7,0,0,1,2.1.253,1.535,1.535,0,0,1,.727-1.683c.948-.572,2.018-.122,2.761,1.1s.645,2.4-.294,2.974a1.532,1.532,0,0,1-1.838-.155A1.709,1.709,0,0,1,385.049,414.668Zm-.359-.621c.711-.433.792-1.315.172-2.336s-1.43-1.364-2.149-.931-.8,1.307-.18,2.336S383.97,414.48,384.689,414.047Zm.645-2.622c.547.9,1.274,1.193,1.9.817.654-.392.711-1.209.18-2.075s-1.258-1.193-1.912-.8C384.869,409.741,384.787,410.518,385.335,411.424Z",
    transform: "translate(-343.925 -345.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11962",
    "data-name": "Path 11962",
    d: "M390.5,420.754c-1.969,1.193-3.652.735-4.6-.841a3.02,3.02,0,0,1-.515-1.56l.621-.049a2.392,2.392,0,0,0,.408,1.291c.752,1.25,2.042,1.568,3.619.613.131-.082.294-.188.458-.31a2.165,2.165,0,0,1-2.067-1.168,2.057,2.057,0,0,1,.555-3.006,2.108,2.108,0,0,1,2.974.907C392.9,418.172,392.334,419.651,390.5,420.754Zm.654-1.511a1.571,1.571,0,0,0,.319-2.279,1.48,1.48,0,1,0-2.483,1.56A1.566,1.566,0,0,0,391.157,419.242Z",
    transform: "translate(-344.642 -346.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11963",
    "data-name": "Path 11963",
    d: "M398.1,426.6l-5.792,3.5-.359-.6,5.269-3.178-.825-1.364.531-.319Z",
    transform: "translate(-345.843 -348.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11964",
    "data-name": "Path 11964",
    d: "M396.78,436.67l-.531.319-2.459-4.068.425-.253,3.815.98a2.239,2.239,0,0,0,1.9-.09c.67-.408.8-1.127.261-2.01a2.294,2.294,0,0,0-1.6-1.193l.106-.645a3.05,3.05,0,0,1,2.067,1.552c.711,1.176.564,2.279-.408,2.867a2.808,2.808,0,0,1-2.385.147l-3.129-.8Z",
    transform: "translate(-346.18 -349.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11965",
    "data-name": "Path 11965",
    d: "M401.881,442.316c-.972.588-2.14.335-2.982-1.07a3.491,3.491,0,0,1-.515-2.533h.645a2.977,2.977,0,0,0,.417,2.206c.58.964,1.348,1.217,2.067.784.694-.417.858-1.185.2-2.263l-.253-.417.441-.261,2.982.392-1.789-2.966.531-.319,2.247,3.725-.425.253-3.055-.392C403.09,440.739,402.812,441.752,401.881,442.316Z",
    transform: "translate(-347.008 -350.387)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7313",
    "data-name": "Group 7313",
    transform: "translate(41.118 82.264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_722",
    "data-name": "Rectangle 722",
    width: 2.941,
    height: 54.252,
    transform: "matrix(0.856, -0.517, 0.517, 0.856, 0, 1.521)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7314",
    "data-name": "Group 7314",
    transform: "translate(49.758 107.91)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_723",
    "data-name": "Rectangle 723",
    width: 2.941,
    height: 27.825,
    transform: "matrix(0.856, -0.517, 0.517, 0.856, 0, 1.521)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7315",
    "data-name": "Group 7315",
    transform: "translate(32.121 19.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11966",
    "data-name": "Path 11966",
    d: "M356.51,339.9l-7.581-12.54a4.062,4.062,0,0,1,1.372-5.571l7.614-4.6a4.062,4.062,0,0,1,5.572,1.372l7.573,12.54a4.05,4.05,0,0,1-1.372,5.563l-7.614,4.6A4.037,4.037,0,0,1,356.51,339.9Z",
    transform: "translate(-348.344 -316.604)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7316",
    "data-name": "Group 7316",
    transform: "translate(34.642 20.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11967",
    "data-name": "Path 11967",
    d: "M351.43,321.72l.931-.564,6.062,10.032a2.452,2.452,0,0,0,4.2-2.532l-6.062-10.032.931-.564,6.062,10.032a3.546,3.546,0,1,1-6.07,3.668Z",
    transform: "translate(-351.43 -318.06)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7317",
    "data-name": "Group 7317",
    transform: "translate(44.842 34.687)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_724",
    "data-name": "Rectangle 724",
    width: 1.095,
    height: 8.047,
    transform: "matrix(0.856, -0.516, 0.516, 0.856, 0, 0.565)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7318",
    "data-name": "Group 7318",
    transform: "translate(54.249 12.914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_725",
    "data-name": "Rectangle 725",
    width: 58.541,
    height: 5.024,
    transform: "translate(4.3 0) rotate(58.861)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7362",
    "data-name": "Group 7362",
    transform: "translate(637.426 97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7324",
    "data-name": "Group 7324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7323",
    "data-name": "Group 7323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11968",
    "data-name": "Path 11968",
    d: "M206.4,33.61c-.621,8.823.008,25.251-3.211,33.494s-7.5,16.731-15.538,20.415c-9.9,4.542-21.534,2.614-32.1,5.277-16.559,4.166-28.527,19.353-33.633,35.643s-4.542,33.739-3.929,50.8l84.495,11.723s.441-34.335,7.81-43.706,42.374-17.8,53.934-43.469c10.408-23.095,13.545-59.717,13.545-59.717Z",
    transform: "translate(-117.602 -33.61)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7325",
    "data-name": "Group 7325",
    transform: "translate(105.488 16.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11969",
    "data-name": "Path 11969",
    d: "M250.676,60.609l-1.086-2.018a3.119,3.119,0,0,1-.466-.033l-1.552-.188-.229,1.83-.613-.074.711-5.768,2.157.27c1.462.18,2.263,1.029,2.108,2.271a1.809,1.809,0,0,1-1.544,1.65l1.16,2.149Zm.433-3.791c.114-.923-.433-1.528-1.585-1.667l-1.536-.188-.359,2.892,1.536.188C250.325,58.183,250.994,57.726,251.109,56.819Z",
    transform: "translate(-246.73 -54.36)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11970",
    "data-name": "Path 11970",
    d: "M258.172,61l-.065.531-4.076-.507.711-5.768,3.954.49-.065.531-3.341-.417-.253,2.05,2.982.368-.065.523-2.982-.368-.261,2.14Z",
    transform: "translate(-248.066 -54.525)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11971",
    "data-name": "Path 11971",
    d: "M260.535,58.961a2.916,2.916,0,0,1,3.39-2.557,2.827,2.827,0,0,1,2.01,1.1l-.433.343a2.258,2.258,0,0,0-1.617-.89,2.409,2.409,0,1,0-.6,4.779,2.255,2.255,0,0,0,1.789-.482l.343.433a2.815,2.815,0,0,1-2.222.588A2.945,2.945,0,0,1,260.535,58.961Z",
    transform: "translate(-249.253 -54.729)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11972",
    "data-name": "Path 11972",
    d: "M272.132,62.723l-.065.531-4.076-.506.711-5.768,3.954.49-.065.531-3.341-.417-.253,2.05,2.982.368-.065.523-2.982-.368-.261,2.14Z",
    transform: "translate(-250.622 -54.84)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11973",
    "data-name": "Path 11973",
    d: "M275.451,57.81l.613.074-.711,5.768-.613-.074Z",
    transform: "translate(-251.858 -54.992)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11974",
    "data-name": "Path 11974",
    d: "M282.761,60.722c-.155,1.225-1.136,1.863-2.6,1.675l-1.552-.188-.229,1.822-.613-.074.711-5.768,2.157.27C282.116,58.639,282.917,59.489,282.761,60.722Zm-.613-.074c.114-.923-.433-1.528-1.585-1.667l-1.536-.188-.359,2.884,1.536.188C281.365,62.013,282.034,61.556,282.149,60.649Z",
    transform: "translate(-252.413 -55.061)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11975",
    "data-name": "Path 11975",
    d: "M286.4,59.684l-2.026-.253.065-.531,4.665.58-.065.531-2.026-.253-.645,5.237-.613-.074Z",
    transform: "translate(-253.621 -55.191)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7327",
    "data-name": "Group 7327",
    transform: "translate(94.819 32.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7326",
    "data-name": "Group 7326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11976",
    "data-name": "Path 11976",
    d: "M267.989,78.2c-.016.114-7.712-.833-17.188-2.124s-17.147-2.434-17.131-2.549,7.712.833,17.188,2.132C260.326,76.943,268,78.086,267.989,78.2Z",
    transform: "translate(-233.67 -73.519)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7329",
    "data-name": "Group 7329",
    transform: "translate(93.888 39.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7328",
    "data-name": "Group 7328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11977",
    "data-name": "Path 11977",
    d: "M266.849,86.621c-.016.114-7.712-.833-17.188-2.124s-17.147-2.434-17.131-2.549,7.712.833,17.188,2.132C259.195,85.363,266.865,86.506,266.849,86.621Z",
    transform: "translate(-232.53 -81.939)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7331",
    "data-name": "Group 7331",
    transform: "translate(90.743 46.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7330",
    "data-name": "Group 7330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11978",
    "data-name": "Path 11978",
    d: "M263,95.211c-.016.114-7.712-.833-17.188-2.124s-17.147-2.434-17.131-2.549,7.712.833,17.188,2.132C255.344,93.953,263.015,95.1,263,95.211Z",
    transform: "translate(-228.68 -90.529)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7333",
    "data-name": "Group 7333",
    transform: "translate(85.016 53.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7332",
    "data-name": "Group 7332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11979",
    "data-name": "Path 11979",
    d: "M255.989,103.871c-.016.114-7.712-.833-17.188-2.124S221.654,99.312,221.67,99.2s7.712.833,17.188,2.132C248.334,102.613,256.005,103.756,255.989,103.871Z",
    transform: "translate(-221.67 -99.189)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7335",
    "data-name": "Group 7335",
    transform: "translate(75.891 60.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7334",
    "data-name": "Group 7334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11980",
    "data-name": "Path 11980",
    d: "M244.819,112.519c-.016.114-7.712-.833-17.188-2.132s-17.147-2.434-17.131-2.549,7.712.833,17.188,2.132S244.835,112.4,244.819,112.519Z",
    transform: "translate(-210.5 -107.829)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7337",
    "data-name": "Group 7337",
    transform: "translate(136.139 38.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7336",
    "data-name": "Group 7336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11981",
    "data-name": "Path 11981",
    d: "M292.632,81.747a42.857,42.857,0,0,1-8.382-1.364,21.68,21.68,0,0,1,4.224.474A21.283,21.283,0,0,1,292.632,81.747Z",
    transform: "translate(-284.25 -80.352)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7339",
    "data-name": "Group 7339",
    transform: "translate(135.845 44.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7338",
    "data-name": "Group 7338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11982",
    "data-name": "Path 11982",
    d: "M292.272,89.257a42.855,42.855,0,0,1-8.382-1.364,42.855,42.855,0,0,1,8.382,1.364Z",
    transform: "translate(-283.89 -87.862)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7341",
    "data-name": "Group 7341",
    transform: "translate(133.761 52.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7340",
    "data-name": "Group 7340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11983",
    "data-name": "Path 11983",
    d: "M289.721,99.644a21.88,21.88,0,0,1-4.232-.49,24.9,24.9,0,0,1-4.15-.874,17.97,17.97,0,0,1,4.223.457A20.919,20.919,0,0,1,289.721,99.644Z",
    transform: "translate(-281.339 -98.234)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7343",
    "data-name": "Group 7343",
    transform: "translate(130.755 59.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7342",
    "data-name": "Group 7342",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11984",
    "data-name": "Path 11984",
    d: "M286.041,108.434a21.882,21.882,0,0,1-4.232-.49,24.907,24.907,0,0,1-4.15-.874,17.972,17.972,0,0,1,4.224.457A20.741,20.741,0,0,1,286.041,108.434Z",
    transform: "translate(-277.659 -107.024)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7345",
    "data-name": "Group 7345",
    transform: "translate(124.293 66.795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7344",
    "data-name": "Group 7344",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11985",
    "data-name": "Path 11985",
    d: "M278.131,116.784a21.883,21.883,0,0,1-4.232-.49,24.908,24.908,0,0,1-4.15-.874,17.969,17.969,0,0,1,4.224.457A21.622,21.622,0,0,1,278.131,116.784Z",
    transform: "translate(-269.749 -115.374)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7347",
    "data-name": "Group 7347",
    transform: "translate(50.852 66.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7346",
    "data-name": "Group 7346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11986",
    "data-name": "Path 11986",
    d: "M231.406,122.494c-.016.114-11.568-1.421-25.807-3.439s-25.766-3.742-25.75-3.856,11.568,1.421,25.807,3.439S231.423,122.379,231.406,122.494Z",
    transform: "translate(-179.85 -115.193)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7349",
    "data-name": "Group 7349",
    transform: "translate(40.894 72.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7348",
    "data-name": "Group 7348",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11987",
    "data-name": "Path 11987",
    d: "M223.211,131a2.516,2.516,0,0,1-.572-.049c-.417-.057-.956-.123-1.626-.212-1.454-.212-3.48-.507-5.964-.866-5.073-.784-12-1.846-19.655-3.031-7.671-1.209-14.615-2.336-19.631-3.17-2.475-.425-4.485-.776-5.939-1.021-.7-.131-1.242-.229-1.609-.31a2.731,2.731,0,0,1-.556-.147,2.922,2.922,0,0,1,.572.057c.417.057.948.131,1.618.229,1.454.221,3.48.523,5.964.89,5.073.784,12,1.863,19.655,3.047,7.646,1.225,14.566,2.336,19.631,3.153,2.475.417,4.493.76,5.947,1,.67.123,1.2.221,1.609.294A2.287,2.287,0,0,1,223.211,131Z",
    transform: "translate(-167.66 -122.184)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7351",
    "data-name": "Group 7351",
    transform: "translate(31.156 79.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7350",
    "data-name": "Group 7350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11988",
    "data-name": "Path 11988",
    d: "M210.245,139.169a9.593,9.593,0,0,1-2.124-.188c-1.389-.18-3.39-.457-5.857-.809-4.942-.719-11.764-1.748-19.288-2.933s-14.345-2.271-19.271-3.088c-2.426-.408-4.4-.743-5.833-.988-.654-.123-1.176-.212-1.585-.294a2.912,2.912,0,0,1-.547-.131,2.438,2.438,0,0,1,.564.049c.408.057.94.123,1.593.212,1.43.212,3.415.5,5.849.858,4.983.768,11.78,1.814,19.288,2.965,7.5,1.193,14.3,2.263,19.271,3.055C206.806,138.606,209.2,139,210.245,139.169Z",
    transform: "translate(-155.74 -130.732)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7353",
    "data-name": "Group 7353",
    transform: "translate(113.493 76.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7352",
    "data-name": "Group 7352",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11989",
    "data-name": "Path 11989",
    d: "M264.911,128.674a21.882,21.882,0,0,1-4.232-.49,24.908,24.908,0,0,1-4.15-.874,17.971,17.971,0,0,1,4.224.457A20.565,20.565,0,0,1,264.911,128.674Z",
    transform: "translate(-256.529 -127.264)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7355",
    "data-name": "Group 7355",
    transform: "translate(105.169 81.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7354",
    "data-name": "Group 7354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11990",
    "data-name": "Path 11990",
    d: "M254.721,134.344a21.881,21.881,0,0,1-4.232-.49,24.91,24.91,0,0,1-4.15-.874,17.97,17.97,0,0,1,4.223.457A20.567,20.567,0,0,1,254.721,134.344Z",
    transform: "translate(-246.339 -132.934)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7357",
    "data-name": "Group 7357",
    transform: "translate(93.961 88.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7356",
    "data-name": "Group 7356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11991",
    "data-name": "Path 11991",
    d: "M241,143.894a21.877,21.877,0,0,1-4.232-.49,24.908,24.908,0,0,1-4.15-.874,17.972,17.972,0,0,1,4.224.457A21.25,21.25,0,0,1,241,143.894Z",
    transform: "translate(-232.619 -142.484)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7359",
    "data-name": "Group 7359",
    transform: "translate(17.203 92.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7358",
    "data-name": "Group 7358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11992",
    "data-name": "Path 11992",
    d: "M202.38,157.092c-.016.114-14.3-1.985-31.893-4.689s-31.852-5-31.828-5.114,14.3,1.985,31.893,4.689S202.4,156.978,202.38,157.092Z",
    transform: "translate(-138.66 -147.285)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7361",
    "data-name": "Group 7361",
    transform: "translate(51.53 114.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7360",
    "data-name": "Group 7360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11993",
    "data-name": "Path 11993",
    d: "M201.52,177.461c-.016.114-4.7-.547-10.457-1.479s-10.408-1.781-10.383-1.9,4.7.547,10.457,1.479S201.536,177.339,201.52,177.461Z",
    transform: "translate(-180.68 -174.074)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(564.894 154.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7693",
    "data-name": "Group 7693",
    transform: "translate(0 4.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7518",
    "data-name": "Group 7518",
    transform: "translate(13.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7515",
    "data-name": "Group 7515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7514",
    "data-name": "Group 7514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7513",
    "data-name": "Group 7513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7508",
    "data-name": "Group 7508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7367",
    "data-name": "Group 7367",
    transform: "translate(8.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7366",
    "data-name": "Group 7366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7365",
    "data-name": "Group 7365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11995",
    "data-name": "Path 11995",
    d: "M93.726,121.7c1.364-2.287.637-5.433-1.242-7.328a10.246,10.246,0,0,0-7.32-2.671,30.447,30.447,0,0,0-7.851,1.405,8.5,8.5,0,0,0-14.991,2.418,5.4,5.4,0,0,0-7.426,6.021l11.135,5.988,9.321,24.647A10.417,10.417,0,0,0,92.64,140.863a8.926,8.926,0,0,0,2.157-1.952,9.12,9.12,0,0,0,5.04-4.926A9.632,9.632,0,0,0,93.726,121.7Z",
    transform: "translate(-54.799 -109.596)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7507",
    "data-name": "Group 7507",
    transform: "translate(0 6.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7475",
    "data-name": "Group 7475",
    transform: "translate(8.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7474",
    "data-name": "Group 7474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7469",
    "data-name": "Group 7469",
    transform: "translate(0 3.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7468",
    "data-name": "Group 7468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7467",
    "data-name": "Group 7467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7466",
    "data-name": "Group 7466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7445",
    "data-name": "Group 7445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7444",
    "data-name": "Group 7444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7443",
    "data-name": "Group 7443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7377",
    "data-name": "Group 7377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7376",
    "data-name": "Group 7376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7375",
    "data-name": "Group 7375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7374",
    "data-name": "Group 7374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7373",
    "data-name": "Group 7373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7372",
    "data-name": "Group 7372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7371",
    "data-name": "Group 7371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7370",
    "data-name": "Group 7370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7369",
    "data-name": "Group 7369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7368",
    "data-name": "Group 7368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11996",
    "data-name": "Path 11996",
    d: "M78.583,169.717c-.155-3.8-.27-6.4-.261-6.372,0,0,7.369-1.618,8.414-11.4.515-4.861-.131-12.76-.866-19.2-.662-5.8-4.885-12.736-10.653-11.829l-17.866,5.506c-1.748.278-2.287,1.8-2.165,3.562l-.106.833,2.271,27.735L57.188,170.4c.408,5.269,5.8,9.893,11.086,9.95h0A10.212,10.212,0,0,0,78.583,169.717Z",
    transform: "translate(-55.08 -120.841)",
    fill: "#ffbe9d"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7399",
    "data-name": "Group 7399",
    transform: "translate(24.105 15.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7387",
    "data-name": "Group 7387",
    transform: "translate(2.065 3.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7386",
    "data-name": "Group 7386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7385",
    "data-name": "Group 7385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7384",
    "data-name": "Group 7384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7383",
    "data-name": "Group 7383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7382",
    "data-name": "Group 7382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7381",
    "data-name": "Group 7381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7380",
    "data-name": "Group 7380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7379",
    "data-name": "Group 7379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7378",
    "data-name": "Group 7378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11997",
    "data-name": "Path 11997",
    d: "M89.594,145.682A1.245,1.245,0,0,1,88.459,147a1.188,1.188,0,0,1-1.34-1.054,1.245,1.245,0,0,1,1.136-1.315A1.187,1.187,0,0,1,89.594,145.682Z",
    transform: "translate(-87.115 -144.621)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7398",
    "data-name": "Group 7398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7397",
    "data-name": "Group 7397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7396",
    "data-name": "Group 7396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7395",
    "data-name": "Group 7395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7394",
    "data-name": "Group 7394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7393",
    "data-name": "Group 7393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7392",
    "data-name": "Group 7392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7391",
    "data-name": "Group 7391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7390",
    "data-name": "Group 7390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7389",
    "data-name": "Group 7389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7388",
    "data-name": "Group 7388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11998",
    "data-name": "Path 11998",
    d: "M89.5,141.494c-.147.172-1.127-.482-2.459-.408-1.34.049-2.287.792-2.434.637-.074-.065.065-.368.482-.7a3.425,3.425,0,0,1,1.944-.711,3.251,3.251,0,0,1,1.969.523C89.417,141.126,89.573,141.412,89.5,141.494Z",
    transform: "translate(-84.587 -140.305)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7421",
    "data-name": "Group 7421",
    transform: "translate(11.312 16.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7409",
    "data-name": "Group 7409",
    transform: "translate(2.751 3.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7408",
    "data-name": "Group 7408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7407",
    "data-name": "Group 7407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7406",
    "data-name": "Group 7406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7405",
    "data-name": "Group 7405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7404",
    "data-name": "Group 7404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7403",
    "data-name": "Group 7403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7402",
    "data-name": "Group 7402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7401",
    "data-name": "Group 7401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7400",
    "data-name": "Group 7400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11999",
    "data-name": "Path 11999",
    d: "M74.774,146.352a1.245,1.245,0,0,1-1.136,1.315,1.188,1.188,0,0,1-1.34-1.054,1.245,1.245,0,0,1,1.136-1.315A1.188,1.188,0,0,1,74.774,146.352Z",
    transform: "translate(-72.295 -145.291)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7420",
    "data-name": "Group 7420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7419",
    "data-name": "Group 7419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7418",
    "data-name": "Group 7418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7417",
    "data-name": "Group 7417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7416",
    "data-name": "Group 7416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7415",
    "data-name": "Group 7415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7414",
    "data-name": "Group 7414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7413",
    "data-name": "Group 7413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7412",
    "data-name": "Group 7412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7411",
    "data-name": "Group 7411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7410",
    "data-name": "Group 7410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12000",
    "data-name": "Path 12000",
    d: "M73.839,141.984c-.147.172-1.127-.482-2.459-.408-1.34.049-2.287.792-2.434.637-.074-.065.065-.368.482-.7a3.426,3.426,0,0,1,1.944-.711,3.308,3.308,0,0,1,1.969.523C73.749,141.616,73.9,141.9,73.839,141.984Z",
    transform: "translate(-68.927 -140.795)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7432",
    "data-name": "Group 7432",
    transform: "translate(20.305 15.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7431",
    "data-name": "Group 7431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7430",
    "data-name": "Group 7430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7429",
    "data-name": "Group 7429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7428",
    "data-name": "Group 7428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7427",
    "data-name": "Group 7427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7426",
    "data-name": "Group 7426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7425",
    "data-name": "Group 7425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7424",
    "data-name": "Group 7424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7423",
    "data-name": "Group 7423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7422",
    "data-name": "Group 7422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12001",
    "data-name": "Path 12001",
    d: "M81.132,151.046a9.206,9.206,0,0,1,2.157-.506c.343-.049.662-.139.7-.376a1.82,1.82,0,0,0-.278-1c-.368-.809-.743-1.658-1.144-2.549a45.064,45.064,0,0,1-2.622-6.691,44.8,44.8,0,0,1,3.153,6.462c.384.9.752,1.748,1.1,2.565a2,2,0,0,1,.245,1.332.868.868,0,0,1-.539.531,2.416,2.416,0,0,1-.58.114A8.783,8.783,0,0,1,81.132,151.046Z",
    transform: "translate(-79.935 -139.919)",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7442",
    "data-name": "Group 7442",
    transform: "translate(10.065 39.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7441",
    "data-name": "Group 7441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7440",
    "data-name": "Group 7440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7439",
    "data-name": "Group 7439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7438",
    "data-name": "Group 7438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7437",
    "data-name": "Group 7437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7436",
    "data-name": "Group 7436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7435",
    "data-name": "Group 7435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7434",
    "data-name": "Group 7434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7433",
    "data-name": "Group 7433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12002",
    "data-name": "Path 12002",
    d: "M80.569,172.244A24.688,24.688,0,0,1,67.4,169.45s3.627,6.674,13.291,5.269Z",
    transform: "translate(-67.4 -169.45)",
    fill: "#eb996e"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7455",
    "data-name": "Group 7455",
    transform: "translate(9.907 10.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7454",
    "data-name": "Group 7454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7453",
    "data-name": "Group 7453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7452",
    "data-name": "Group 7452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7451",
    "data-name": "Group 7451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7450",
    "data-name": "Group 7450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7449",
    "data-name": "Group 7449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7448",
    "data-name": "Group 7448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7447",
    "data-name": "Group 7447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7446",
    "data-name": "Group 7446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12003",
    "data-name": "Path 12003",
    d: "M73.345,135.3c-.147.359-1.479.139-3.055.278-1.585.106-2.867.523-3.063.188-.09-.163.147-.5.67-.833a5.347,5.347,0,0,1,4.656-.351C73.124,134.839,73.41,135.133,73.345,135.3Z",
    transform: "translate(-67.207 -134.21)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7465",
    "data-name": "Group 7465",
    transform: "translate(23.447 10.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7464",
    "data-name": "Group 7464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7463",
    "data-name": "Group 7463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7462",
    "data-name": "Group 7462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7461",
    "data-name": "Group 7461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7460",
    "data-name": "Group 7460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7459",
    "data-name": "Group 7459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7458",
    "data-name": "Group 7458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7457",
    "data-name": "Group 7457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7456",
    "data-name": "Group 7456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12004",
    "data-name": "Path 12004",
    d: "M89.188,135.46c-.261.319-1.372.057-2.68.114-1.315.016-2.41.327-2.688.024-.123-.147.041-.466.506-.776a4.255,4.255,0,0,1,2.157-.613,4.188,4.188,0,0,1,2.173.5C89.139,135,89.3,135.3,89.188,135.46Z",
    transform: "translate(-83.782 -134.208)",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7473",
    "data-name": "Group 7473",
    transform: "translate(6.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7472",
    "data-name": "Group 7472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7471",
    "data-name": "Group 7471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7470",
    "data-name": "Group 7470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12005",
    "data-name": "Path 12005",
    d: "M63.9,120.121a6.643,6.643,0,0,0,8.153,6.168c1.47-.343,3.055-1.176,4.379-.449,1.389.768,1.544,2.794,2.794,3.774,1.781,1.4,4.436-.123,6.633.408,1.7.417,2.827,1.969,4,3.26s2.908,2.492,4.567,1.912a19.771,19.771,0,0,0-.882-4.436,6.66,6.66,0,0,0-2.72-3.521,23.447,23.447,0,0,1-2.206-1.144c-1.446-1.054-1.863-3-2.8-4.518a7.283,7.283,0,0,0-5.718-3.407c-1.92-.1-3.856.572-5.735.188-1.389-.278-2.639-1.111-4.044-1.307-2.737-.384-5.163,1.691-7.034,3.725",
    transform: "translate(-63.29 -117.003)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7478",
    "data-name": "Group 7478",
    transform: "translate(0 1.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7477",
    "data-name": "Group 7477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7476",
    "data-name": "Group 7476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12006",
    "data-name": "Path 12006",
    d: "M69.39,123.809c-1.234-.286-3.758-.956-4.46-1.977a7.445,7.445,0,0,0-6.65-3.4,6.139,6.139,0,0,0-5.286,5.122,8.83,8.83,0,0,0-7.344,5.253,10.214,10.214,0,0,0,.743,9.493,18.719,18.719,0,0,1,1.1,2.3,15.19,15.19,0,0,0-1.92,2.108c-2.68,4.1,2.459,6.633,2.459,6.633-.449,2.965,2.287,3.382,4.036,3.644,1.683.253,1.993,5.089,3.382,5.122l.874-14.647a1.776,1.776,0,0,0,.621.212c3.292.58,3.415-5.808,2.6-7.589a18.731,18.731,0,0,0,3.1-3.6,13.711,13.711,0,0,0,1.176-6.658C65.011,125.835,69.929,123.939,69.39,123.809Z",
    transform: "translate(-44.803 -118.403)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7506",
    "data-name": "Group 7506",
    transform: "translate(6.165 24.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7491",
    "data-name": "Group 7491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7490",
    "data-name": "Group 7490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7489",
    "data-name": "Group 7489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7488",
    "data-name": "Group 7488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7487",
    "data-name": "Group 7487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7486",
    "data-name": "Group 7486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7485",
    "data-name": "Group 7485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7484",
    "data-name": "Group 7484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7483",
    "data-name": "Group 7483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7482",
    "data-name": "Group 7482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7481",
    "data-name": "Group 7481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7480",
    "data-name": "Group 7480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7479",
    "data-name": "Group 7479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12007",
    "data-name": "Path 12007",
    d: "M58.093,149.522a2.832,2.832,0,0,0-4.256-2.206c-.956.613-1.65,1.8-1.454,3.978.531,5.833,6.274,4.1,6.266,3.929C58.648,155.126,58.33,151.932,58.093,149.522Z",
    transform: "translate(-52.349 -146.899)",
    fill: "#ffbe9d"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7505",
    "data-name": "Group 7505",
    transform: "translate(1.511 1.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7504",
    "data-name": "Group 7504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7503",
    "data-name": "Group 7503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7502",
    "data-name": "Group 7502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7501",
    "data-name": "Group 7501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7500",
    "data-name": "Group 7500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7499",
    "data-name": "Group 7499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7498",
    "data-name": "Group 7498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7497",
    "data-name": "Group 7497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7496",
    "data-name": "Group 7496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7495",
    "data-name": "Group 7495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7494",
    "data-name": "Group 7494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7493",
    "data-name": "Group 7493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7492",
    "data-name": "Group 7492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12008",
    "data-name": "Path 12008",
    d: "M57.01,153.578c-.025-.016-.1.082-.261.172a1.017,1.017,0,0,1-.76.082,2.522,2.522,0,0,1-1.364-2.149,3.248,3.248,0,0,1,.155-1.479,1.186,1.186,0,0,1,.694-.85.515.515,0,0,1,.621.221c.09.155.065.278.1.286.016.016.114-.106.049-.343a.628.628,0,0,0-.261-.343.784.784,0,0,0-.572-.1,1.433,1.433,0,0,0-.98,1,3.45,3.45,0,0,0-.2,1.658,2.661,2.661,0,0,0,1.707,2.385,1.078,1.078,0,0,0,.915-.237C57.01,153.717,57.026,153.586,57.01,153.578Z",
    transform: "translate(-54.199 -149.061)",
    fill: "#eb996e"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7512",
    "data-name": "Group 7512",
    transform: "translate(1.107 3.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7511",
    "data-name": "Group 7511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7510",
    "data-name": "Group 7510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7509",
    "data-name": "Group 7509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12009",
    "data-name": "Path 12009",
    d: "M48.643,131.306a1.216,1.216,0,0,1-.253-.2,8.824,8.824,0,0,1-.637-.662,6.783,6.783,0,0,1-1.495-3.023,5.364,5.364,0,0,1,.065-2.353,4.787,4.787,0,0,1,1.364-2.336,3.86,3.86,0,0,1,2.794-1.046,3.579,3.579,0,0,1,2.851,1.446l-.27.131a.154.154,0,0,1-.016-.065,8.038,8.038,0,0,1,.327-6.094,5.262,5.262,0,0,1,4-2.892,4.3,4.3,0,0,1,3.211,1,3.443,3.443,0,0,1,.613.7,1.619,1.619,0,0,1,.147.286,5.567,5.567,0,0,0-.833-.9,4.256,4.256,0,0,0-3.1-.874,5.076,5.076,0,0,0-3.774,2.8,7.832,7.832,0,0,0-.286,5.866.192.192,0,0,1,.016.065l.27.907-.547-.776a3.293,3.293,0,0,0-2.606-1.315,3.591,3.591,0,0,0-2.59.948,4.619,4.619,0,0,0-1.307,2.2,5.076,5.076,0,0,0-.1,2.255,6.944,6.944,0,0,0,1.372,2.99C48.324,131,48.659,131.282,48.643,131.306Z",
    transform: "translate(-46.158 -114.198)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7517",
    "data-name": "Group 7517",
    transform: "translate(5.245 37.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7516",
    "data-name": "Group 7516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12010",
    "data-name": "Path 12010",
    d: "M53.394,156.11a3.684,3.684,0,0,0-.7.376,3.6,3.6,0,0,0-1.144,1.814,4.086,4.086,0,0,0-.188,1.479,3.373,3.373,0,0,0,.523,1.609,3.9,3.9,0,0,0,1.372,1.274,3.379,3.379,0,0,0,1.944.449,3.559,3.559,0,0,0,1.871-.7,3.352,3.352,0,0,0,1.119-1.487,3.812,3.812,0,0,0-.082-3.112,2.948,2.948,0,0,0-1.577-1.413,3.36,3.36,0,0,0-.784-.155.851.851,0,0,1,.212-.008,2.293,2.293,0,0,1,.6.106,2.952,2.952,0,0,1,1.658,1.422,3.888,3.888,0,0,1,.123,3.219,3.6,3.6,0,0,1-3.121,2.3,3.467,3.467,0,0,1-2.034-.474,4.057,4.057,0,0,1-1.421-1.332,3.475,3.475,0,0,1-.531-1.683,4.275,4.275,0,0,1,.221-1.519,3.574,3.574,0,0,1,1.217-1.83,2.257,2.257,0,0,1,.539-.278A.807.807,0,0,1,53.394,156.11Z",
    transform: "translate(-51.223 -156.108)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12011",
    "data-name": "Path 12011",
    d: "M80.672,157.314a1.27,1.27,0,0,0-1.413-.711,1.061,1.061,0,0,0-1.037.9,1.322,1.322,0,0,0,.2,1.054,1.427,1.427,0,0,0,.776.547,1.33,1.33,0,0,0,1.119-.2A1.672,1.672,0,0,0,80.672,157.314Z",
    transform: "translate(-50.914 -118.196)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7661",
    "data-name": "Group 7661",
    transform: "translate(2.104 116.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7582",
    "data-name": "Group 7582",
    transform: "translate(22.546 142.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7526",
    "data-name": "Group 7526",
    transform: "translate(1.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7525",
    "data-name": "Group 7525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7524",
    "data-name": "Group 7524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7523",
    "data-name": "Group 7523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7522",
    "data-name": "Group 7522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7521",
    "data-name": "Group 7521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7520",
    "data-name": "Group 7520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7519",
    "data-name": "Group 7519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12012",
    "data-name": "Path 12012",
    d: "M61.05,427.466l3.006,25.921,11.355-1.732.768-25.545Z",
    transform: "translate(-61.05 -426.11)",
    fill: "#ffbe9d"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7581",
    "data-name": "Group 7581",
    transform: "translate(0 20.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7532",
    "data-name": "Group 7532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7531",
    "data-name": "Group 7531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7530",
    "data-name": "Group 7530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7529",
    "data-name": "Group 7529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7528",
    "data-name": "Group 7528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7527",
    "data-name": "Group 7527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12013",
    "data-name": "Path 12013",
    d: "M75.075,451.09s-7.622,6.462-11.87,1.716l-.841,2.524-3.333,17.8a2.36,2.36,0,0,0,1.487,2.7,2.191,2.191,0,0,0,2.3-.637c3.08-3.48,14.337-16.322,14.108-17.932l-.351-4.281a2.184,2.184,0,0,0-1.5-1.9Z",
    transform: "translate(-58.988 -451.09)",
    fill: "#ff725e"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7538",
    "data-name": "Group 7538",
    transform: "translate(1.921 4.689)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7537",
    "data-name": "Group 7537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7536",
    "data-name": "Group 7536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7535",
    "data-name": "Group 7535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7534",
    "data-name": "Group 7534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7533",
    "data-name": "Group 7533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12014",
    "data-name": "Path 12014",
    d: "M61.34,476.975,77.254,456.83l.065.939a2.683,2.683,0,0,1-.67,2.132c-1.258,2.034-4.812,6.642-13.332,16.347a2.23,2.23,0,0,1-1.977.727Z",
    transform: "translate(-61.34 -456.83)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7545",
    "data-name": "Group 7545",
    transform: "translate(14.63 1.829)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7544",
    "data-name": "Group 7544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7543",
    "data-name": "Group 7543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7542",
    "data-name": "Group 7542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7541",
    "data-name": "Group 7541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7540",
    "data-name": "Group 7540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7539",
    "data-name": "Group 7539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12015",
    "data-name": "Path 12015",
    d: "M77.373,453.6a1.393,1.393,0,0,0-.245,1.814,1.278,1.278,0,0,0,1.756.261,1.485,1.485,0,0,0,.253-1.928,1.317,1.317,0,0,0-1.854-.065",
    transform: "translate(-76.897 -453.329)",
    fill: "#fff"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7552",
    "data-name": "Group 7552",
    transform: "translate(1.683 12.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7551",
    "data-name": "Group 7551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7550",
    "data-name": "Group 7550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7549",
    "data-name": "Group 7549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7548",
    "data-name": "Group 7548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7547",
    "data-name": "Group 7547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7546",
    "data-name": "Group 7546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12016",
    "data-name": "Path 12016",
    d: "M65.575,468.716a6.612,6.612,0,0,0-2.01-1.577,6.418,6.418,0,0,0-2.516-.3c-.025-.049.237-.245.743-.351a3.424,3.424,0,0,1,1.961.2,3.462,3.462,0,0,1,1.544,1.25C65.575,468.373,65.624,468.692,65.575,468.716Z",
    transform: "translate(-61.048 -466.422)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7559",
    "data-name": "Group 7559",
    transform: "translate(0.765 16.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7558",
    "data-name": "Group 7558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7557",
    "data-name": "Group 7557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7556",
    "data-name": "Group 7556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7555",
    "data-name": "Group 7555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7554",
    "data-name": "Group 7554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7553",
    "data-name": "Group 7553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12017",
    "data-name": "Path 12017",
    d: "M64.03,472.682c-.1.106-.833-.564-1.977-.809a19.018,19.018,0,0,0-2.124-.123,2.421,2.421,0,0,1,2.23-.351C63.458,471.686,64.136,472.617,64.03,472.682Z",
    transform: "translate(-59.925 -471.31)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7566",
    "data-name": "Group 7566",
    transform: "translate(2.598 8.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7565",
    "data-name": "Group 7565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7564",
    "data-name": "Group 7564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7563",
    "data-name": "Group 7563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7562",
    "data-name": "Group 7562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7561",
    "data-name": "Group 7561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7560",
    "data-name": "Group 7560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12018",
    "data-name": "Path 12018",
    d: "M68.387,463.827a21.889,21.889,0,0,0-2.965-1.462,22.58,22.58,0,0,0-3.251-.531,5.95,5.95,0,0,1,6.217,1.993Z",
    transform: "translate(-62.169 -461.582)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7573",
    "data-name": "Group 7573",
    transform: "translate(3.177 4.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7572",
    "data-name": "Group 7572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7571",
    "data-name": "Group 7571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7570",
    "data-name": "Group 7570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7569",
    "data-name": "Group 7569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7568",
    "data-name": "Group 7568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7567",
    "data-name": "Group 7567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12019",
    "data-name": "Path 12019",
    d: "M68.524,457.628c-.049.139-1.274-.286-2.827-.229-1.56.033-2.761.531-2.818.392a4.211,4.211,0,0,1,2.8-.882A4.238,4.238,0,0,1,68.524,457.628Z",
    transform: "translate(-62.877 -456.907)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7580",
    "data-name": "Group 7580",
    transform: "translate(2 1.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7579",
    "data-name": "Group 7579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7578",
    "data-name": "Group 7578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7577",
    "data-name": "Group 7577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7576",
    "data-name": "Group 7576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7575",
    "data-name": "Group 7575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7574",
    "data-name": "Group 7574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12020",
    "data-name": "Path 12020",
    d: "M64.544,456.624a2.035,2.035,0,0,1,.065-.833,5.793,5.793,0,0,1,.89-2.108,2.553,2.553,0,0,1,1.209-1.1.867.867,0,0,1,.972.31,1.5,1.5,0,0,1,.229,1.029,3.176,3.176,0,0,1-3.055,2.647,3.611,3.611,0,0,1-3.333-2.336,1.329,1.329,0,0,1,.057-1.07.864.864,0,0,1,.964-.368,3.042,3.042,0,0,1,1.332.915,6.432,6.432,0,0,1,1.274,1.879,1.964,1.964,0,0,1,.245.8,10.322,10.322,0,0,0-1.756-2.426,2.835,2.835,0,0,0-1.185-.768.462.462,0,0,0-.523.2.924.924,0,0,0,0,.711,3.222,3.222,0,0,0,2.908,1.985,2.74,2.74,0,0,0,2.622-2.206,1.106,1.106,0,0,0-.131-.727.485.485,0,0,0-.539-.18,2.245,2.245,0,0,0-1.037.915A8.929,8.929,0,0,0,64.544,456.624Z",
    transform: "translate(-61.436 -452.535)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7657",
    "data-name": "Group 7657",
    transform: "translate(66.596 150.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7583",
    "data-name": "Group 7583",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12021",
    "data-name": "Path 12021",
    d: "M115.549,449.839c-.261-.4-2.639-9.076-2.639-9.076l14.7-4,2.083,12.5Z",
    transform: "translate(-112.91 -436.76)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7656",
    "data-name": "Group 7656",
    transform: "translate(1.078 9.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7655",
    "data-name": "Group 7655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7654",
    "data-name": "Group 7654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7594",
    "data-name": "Group 7594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7593",
    "data-name": "Group 7593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7592",
    "data-name": "Group 7592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7591",
    "data-name": "Group 7591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7590",
    "data-name": "Group 7590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7589",
    "data-name": "Group 7589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7588",
    "data-name": "Group 7588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7587",
    "data-name": "Group 7587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7586",
    "data-name": "Group 7586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7585",
    "data-name": "Group 7585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7584",
    "data-name": "Group 7584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12022",
    "data-name": "Path 12022",
    d: "M129.809,449.015l.016,1s16.183,6.593,16.388,9.8l-31.983.229.359-11.184A17.473,17.473,0,0,0,129.809,449.015Z",
    transform: "translate(-114.23 -448.86)",
    fill: "#ff725e"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7606",
    "data-name": "Group 7606",
    transform: "translate(2.707 3.498)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7605",
    "data-name": "Group 7605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7604",
    "data-name": "Group 7604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7603",
    "data-name": "Group 7603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7602",
    "data-name": "Group 7602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7601",
    "data-name": "Group 7601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7600",
    "data-name": "Group 7600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7599",
    "data-name": "Group 7599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7598",
    "data-name": "Group 7598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7597",
    "data-name": "Group 7597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7596",
    "data-name": "Group 7596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7595",
    "data-name": "Group 7595"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12023",
    "data-name": "Path 12023",
    d: "M118.464,453.2a1.376,1.376,0,0,0-.89,1.577,1.266,1.266,0,0,0,1.479.948,1.467,1.467,0,0,0,.939-1.675,1.283,1.283,0,0,0-1.642-.8",
    transform: "translate(-117.544 -453.142)",
    fill: "#fff"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7617",
    "data-name": "Group 7617",
    transform: "translate(0 8.504)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7616",
    "data-name": "Group 7616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7615",
    "data-name": "Group 7615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7614",
    "data-name": "Group 7614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7613",
    "data-name": "Group 7613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7612",
    "data-name": "Group 7612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7611",
    "data-name": "Group 7611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7610",
    "data-name": "Group 7610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7609",
    "data-name": "Group 7609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7608",
    "data-name": "Group 7608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7607",
    "data-name": "Group 7607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12024",
    "data-name": "Path 12024",
    d: "M114.23,461.958l.09-2.688,30.618.76s1.43.637,1.274,1.7Z",
    transform: "translate(-114.23 -459.27)",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7629",
    "data-name": "Group 7629",
    transform: "translate(12.793 1.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7628",
    "data-name": "Group 7628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7627",
    "data-name": "Group 7627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7626",
    "data-name": "Group 7626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7625",
    "data-name": "Group 7625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7624",
    "data-name": "Group 7624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7623",
    "data-name": "Group 7623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7622",
    "data-name": "Group 7622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7621",
    "data-name": "Group 7621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7620",
    "data-name": "Group 7620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7619",
    "data-name": "Group 7619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7618",
    "data-name": "Group 7618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12025",
    "data-name": "Path 12025",
    d: "M132.8,450.356c0,.163-.784.245-1.552.776-.776.515-1.168,1.225-1.315,1.16-.147-.033.082-1.013,1.021-1.642S132.839,450.2,132.8,450.356Z",
    transform: "translate(-129.89 -450.205)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7641",
    "data-name": "Group 7641",
    transform: "translate(16.961 2.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7640",
    "data-name": "Group 7640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7639",
    "data-name": "Group 7639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7638",
    "data-name": "Group 7638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7637",
    "data-name": "Group 7637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7636",
    "data-name": "Group 7636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7635",
    "data-name": "Group 7635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7634",
    "data-name": "Group 7634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7633",
    "data-name": "Group 7633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7632",
    "data-name": "Group 7632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7631",
    "data-name": "Group 7631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7630",
    "data-name": "Group 7630"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12026",
    "data-name": "Path 12026",
    d: "M137.1,452.125c.033.155-.637.441-1.16,1.144-.547.678-.678,1.43-.833,1.43-.147.024-.261-.931.408-1.789S137.1,451.97,137.1,452.125Z",
    transform: "translate(-134.992 -452.061)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7653",
    "data-name": "Group 7653",
    transform: "translate(20.811 4.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7652",
    "data-name": "Group 7652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7651",
    "data-name": "Group 7651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7650",
    "data-name": "Group 7650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7649",
    "data-name": "Group 7649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7648",
    "data-name": "Group 7648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7647",
    "data-name": "Group 7647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7646",
    "data-name": "Group 7646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7645",
    "data-name": "Group 7645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7644",
    "data-name": "Group 7644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7643",
    "data-name": "Group 7643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7642",
    "data-name": "Group 7642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12027",
    "data-name": "Path 12027",
    d: "M139.9,456.654c-.139.033-.368-.784.033-1.683s1.119-1.266,1.193-1.127c.09.131-.384.621-.694,1.364C140.093,455.943,140.052,456.637,139.9,456.654Z",
    transform: "translate(-139.705 -453.815)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7660",
    "data-name": "Group 7660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7658",
    "data-name": "Group 7658",
    transform: "translate(33.747 11.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12028",
    "data-name": "Path 12028",
    d: "M100.377,266.25c.694.449,5.964,32.015,12.826,73.965,5.645,34.507,8.929,69.447,8.929,69.447l-15.824,3.088s-14.9-42.774-22.784-73.54C76.254,310.838,72.7,290.97,72.7,290.97V270.2Z",
    transform: "translate(-72.7 -266.25)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7659",
    "data-name": "Group 7659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12029",
    "data-name": "Path 12029",
    d: "M44.812,252.03s-14.574,19.7-13.349,40.266c.735,12.3,24.157,117.18,24.157,117.18H73.053l-5.694-115.53,1.667-26.9Z",
    transform: "translate(-31.39 -252.03)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7685",
    "data-name": "Group 7685",
    transform: "translate(0 53.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12030",
    "data-name": "Path 12030",
    d: "M103.559,184.79s4.983.809,7.589,7.892c2.72,7.377,5.817,24.688,5.817,24.688L98.11,219.134l.6-28.315Z",
    transform: "translate(-41.501 -176.678)",
    fill: "#508c76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12031",
    "data-name": "Path 12031",
    d: "M38.385,184.43s-7.99,2.132-9.084,15.138c-.6,7.181-.474,19.5-.474,19.5s2.475.858,9.346-1.9a15.678,15.678,0,0,1,10.963.082l-9.068-27.057Z",
    transform: "translate(-28.815 -176.612)",
    fill: "#508c76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12032",
    "data-name": "Path 12032",
    d: "M53.1,174.86,49.682,178.8l-11.339,4.174L40.81,231.04l-7.05,28.936s6.879,1.332,9.607,4.967,10.832,7.769,20.921,8.431,18.683-5.62,22.653-7.606,10.375-3.619,11.176-5.792c.523-1.43-5.547-43.983-5.547-43.983l-.792-33.02-10.31-2.385-4.019-3.349L62.712,189.548l-3.325-4.134Z",
    transform: "translate(-29.721 -174.86)",
    fill: "#508c76"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7662",
    "data-name": "Group 7662",
    transform: "translate(6.637 76.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12033",
    "data-name": "Path 12033",
    d: "M97.523,268.31a5.391,5.391,0,0,1-.556.376c-.4.245-.948.58-1.634,1-1.43.858-3.5,2.091-6.119,3.521a73.9,73.9,0,0,1-9.509,4.4,41.392,41.392,0,0,1-12.524,2.72,29.416,29.416,0,0,1-12.638-1.977,24.532,24.532,0,0,1-4.91-2.737c-1.421-1.046-2.647-2.116-3.84-3a16.5,16.5,0,0,0-3.415-2.05,9.757,9.757,0,0,0-2.892-.76A8.31,8.31,0,0,0,36.94,270a.647.647,0,0,1,.155-.065,3.416,3.416,0,0,1,.482-.139,6.5,6.5,0,0,1,1.92-.147,9.434,9.434,0,0,1,2.965.711,16.379,16.379,0,0,1,3.5,2.026c1.209.874,2.451,1.944,3.864,2.957a24.089,24.089,0,0,0,4.853,2.663,29.343,29.343,0,0,0,12.483,1.92,41.659,41.659,0,0,0,12.417-2.671,79.017,79.017,0,0,0,9.5-4.305c2.631-1.389,4.722-2.59,6.176-3.407.7-.392,1.258-.7,1.675-.939A3.56,3.56,0,0,1,97.523,268.31Z",
    transform: "translate(-36.94 -268.308)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7663",
    "data-name": "Group 7663",
    transform: "translate(8.492 64.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12034",
    "data-name": "Path 12034",
    d: "M96.313,253.66a4.338,4.338,0,0,1-.49.376c-.327.237-.817.58-1.454,1a60.345,60.345,0,0,1-5.612,3.251,55.5,55.5,0,0,1-8.929,3.611A45.764,45.764,0,0,1,68.2,263.863a40,40,0,0,1-11.715-1.3,33.953,33.953,0,0,1-4.869-1.691c-1.487-.645-2.81-1.364-4.019-1.985a16.149,16.149,0,0,0-6.037-2.1,9.477,9.477,0,0,0-2.353.147,3.028,3.028,0,0,1,.6-.172,6.82,6.82,0,0,1,1.765-.131,15.62,15.62,0,0,1,6.16,2c1.225.613,2.549,1.307,4.019,1.936a34.926,34.926,0,0,0,4.836,1.642,40.135,40.135,0,0,0,11.609,1.258,45.871,45.871,0,0,0,11.527-1.92,56.838,56.838,0,0,0,8.9-3.513c2.451-1.209,4.354-2.336,5.661-3.129q.931-.576,1.495-.931A2.545,2.545,0,0,1,96.313,253.66Z",
    transform: "translate(-39.21 -253.658)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7664",
    "data-name": "Group 7664",
    transform: "translate(11.792 53.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12035",
    "data-name": "Path 12035",
    d: "M95.215,240.89a3.288,3.288,0,0,1-.359.408,9.8,9.8,0,0,1-1.185,1.038,16.44,16.44,0,0,1-5.187,2.508,52.892,52.892,0,0,1-8.39,1.634,82.879,82.879,0,0,1-29.3-1.462c-2.369-.572-4.256-1.111-5.555-1.528-.613-.2-1.1-.376-1.487-.5a3,3,0,0,1-.506-.2,2.708,2.708,0,0,1,.531.123c.384.106.882.253,1.5.425,1.307.368,3.2.866,5.571,1.405a88.112,88.112,0,0,0,18.789,2.018,87.019,87.019,0,0,0,10.391-.645,55.932,55.932,0,0,0,8.357-1.544,17.245,17.245,0,0,0,5.171-2.361C94.675,241.421,95.182,240.857,95.215,240.89Z",
    transform: "translate(-43.25 -240.888)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7665",
    "data-name": "Group 7665",
    transform: "translate(10.885 42.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12036",
    "data-name": "Path 12036",
    d: "M94.464,226.83a2.444,2.444,0,0,1-.506.172c-.376.106-.866.245-1.479.417-.645.18-1.438.392-2.361.6s-1.969.482-3.145.719c-2.336.507-5.138,1.013-8.267,1.462-3.129.433-6.593.8-10.236,1.021-3.643.2-7.124.237-10.285.172-3.161-.09-6-.261-8.382-.5-1.193-.1-2.263-.237-3.211-.351s-1.756-.221-2.41-.327q-.944-.147-1.519-.245a2.066,2.066,0,0,1-.523-.114,2.676,2.676,0,0,1,.539.033c.392.041.9.1,1.528.172.662.082,1.47.18,2.418.261s2.018.212,3.2.286c2.377.2,5.212.343,8.365.417,3.153.049,6.617,0,10.252-.2,3.635-.221,7.083-.58,10.2-.988,3.121-.433,5.923-.907,8.259-1.381,1.176-.212,2.222-.466,3.153-.662s1.724-.384,2.369-.539q.931-.208,1.495-.343A5.088,5.088,0,0,1,94.464,226.83Z",
    transform: "translate(-42.14 -226.829)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7666",
    "data-name": "Group 7666",
    transform: "translate(14.618 30.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12037",
    "data-name": "Path 12037",
    d: "M89.762,212.47a1.629,1.629,0,0,1-.417.147l-1.217.343c-1.054.3-2.606.662-4.526,1.087a81.264,81.264,0,0,1-15.244,1.724c-6,.082-11.421-.376-15.326-.678-1.912-.163-3.48-.3-4.632-.4-.506-.049-.923-.09-1.258-.131a1.468,1.468,0,0,1-.433-.074,1.672,1.672,0,0,1,.441-.008c.335.016.752.033,1.266.049,1.152.065,2.72.155,4.64.27,3.913.229,9.321.637,15.3.555a88.36,88.36,0,0,0,15.195-1.6c1.92-.384,3.472-.711,4.542-.964.5-.106.907-.2,1.234-.27C89.607,212.486,89.754,212.461,89.762,212.47Z",
    transform: "translate(-46.71 -212.468)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7667",
    "data-name": "Group 7667",
    transform: "translate(9.856 18.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12038",
    "data-name": "Path 12038",
    d: "M91.382,197.246a2.381,2.381,0,0,1-.515.057c-.376.025-.866.049-1.479.09-1.332.073-3.178.163-5.433.286a143.232,143.232,0,0,0-17.8,2.01,82.534,82.534,0,0,1-17.9,1.47,43.916,43.916,0,0,1-5.424-.572c-.637-.1-1.119-.221-1.454-.286a2.263,2.263,0,0,1-.5-.131,2.694,2.694,0,0,1,.515.049c.335.041.825.139,1.462.212a53.5,53.5,0,0,0,5.408.441A88.486,88.486,0,0,0,66.082,199.3a128.914,128.914,0,0,1,17.858-1.9c2.3-.1,4.158-.139,5.441-.155.613-.008,1.1-.008,1.479-.008A1.975,1.975,0,0,1,91.382,197.246Z",
    transform: "translate(-40.88 -197.226)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12039",
    "data-name": "Path 12039",
    d: "M53.69,180.91l3.545,15.244,2.132-2.982Z",
    transform: "translate(-33.369 -175.968)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7668",
    "data-name": "Group 7668",
    transform: "translate(19.852 3.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12040",
    "data-name": "Path 12040",
    d: "M64.777,189.131a2.193,2.193,0,0,1-.253.49c-.188.3-.474.735-.858,1.274-.752,1.078-1.936,2.532-3.137,4.338l-.172.261-.147-.278c-.686-1.315-1.413-2.778-2.157-4.33-1.462-3.064-2.7-5.874-3.586-7.916-.441-1.021-.784-1.854-1.021-2.426a4.993,4.993,0,0,1-.327-.915,4.963,4.963,0,0,1,.466.85c.3.637.686,1.43,1.136,2.377.98,2.083,2.263,4.828,3.684,7.859.743,1.544,1.462,3.014,2.124,4.338l-.319-.016c1.25-1.822,2.459-3.235,3.268-4.272S64.736,189.106,64.777,189.131Z",
    transform: "translate(-53.116 -179.63)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7669",
    "data-name": "Group 7669",
    transform: "translate(44.657 40.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12041",
    "data-name": "Path 12041",
    d: "M83.488,225.846a1.426,1.426,0,0,1,.31-.065q.343-.061.907-.147c.8-.122,1.969-.286,3.472-.457,3.006-.351,7.32-.743,12.564-.866h.147l.016.147c.368,3.178.784,6.7,1.217,10.457.221,1.879.441,3.823.67,5.817.114,1,.229,2.01.351,3.023.057.507.114,1.021.18,1.536a6.544,6.544,0,0,1,.074,1.617,1.438,1.438,0,0,1-.621.972,2.561,2.561,0,0,1-1.037.368c-.7.09-1.364.106-2.034.155-1.34.09-2.655.172-3.954.261s-2.565.163-3.815.245a13.688,13.688,0,0,1-3.7-.041,3.789,3.789,0,0,1-2.688-2.255,11.179,11.179,0,0,1-.776-3.235c-.261-2.108-.457-4.076-.613-5.874-.3-3.595-.457-6.511-.564-8.529-.041-.98-.074-1.756-.1-2.32-.008-.245-.008-.441-.016-.6a.807.807,0,0,1,.008-.2.773.773,0,0,1,.033.2c.016.155.033.359.057.6.041.564.1,1.332.172,2.32.147,2.01.343,4.926.686,8.512.172,1.8.384,3.758.654,5.857a11.176,11.176,0,0,0,.768,3.129,3.421,3.421,0,0,0,2.451,2.042,13.549,13.549,0,0,0,3.594.016c1.25-.082,2.516-.172,3.815-.253s2.614-.172,3.954-.261c.662-.057,1.356-.074,2-.155s1.25-.392,1.332-1.013a5.864,5.864,0,0,0-.074-1.495c-.057-.515-.114-1.029-.172-1.536-.114-1.021-.229-2.026-.343-3.023q-.343-2.99-.662-5.825c-.417-3.766-.817-7.287-1.168-10.465l.163.147c-5.228.082-9.542.425-12.548.727-1.479.155-2.647.286-3.48.368l-.915.1A3.109,3.109,0,0,1,83.488,225.846Z",
    transform: "translate(-83.48 -224.31)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7670",
    "data-name": "Group 7670",
    transform: "translate(45.123 46.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12042",
    "data-name": "Path 12042",
    d: "M101.622,231.642c.008.106-3.921.433-8.774.727s-8.79.441-8.8.327,3.921-.433,8.774-.727S101.614,231.536,101.622,231.642Z",
    transform: "translate(-84.05 -231.608)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7671",
    "data-name": "Group 7671",
    transform: "translate(37.756 17.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12043",
    "data-name": "Path 12043",
    d: "M75.749,277.41a.738.738,0,0,1-.025-.212c-.008-.163-.016-.359-.025-.613-.008-.572-.025-1.356-.041-2.353-.025-2.075-.065-5.024-.114-8.651-.1-7.336-.237-17.417-.392-28.552-.131-11.151-.155-21.256-.074-28.568.041-3.652.09-6.609.155-8.651q.049-1.495.074-2.353c.008-.253.024-.449.033-.613a.641.641,0,0,1,.025-.2.621.621,0,0,1,.016.212c0,.163.008.359.008.613v2.353c-.008,2.075-.016,5.024-.025,8.651-.008,7.311.057,17.4.188,28.56s.253,21.248.278,28.56c.016,3.652.008,6.609-.008,8.659-.016,1-.025,1.789-.033,2.353-.008.253-.016.449-.016.613A1.441,1.441,0,0,1,75.749,277.41Z",
    transform: "translate(-75.032 -196.64)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7672",
    "data-name": "Group 7672",
    transform: "translate(15.246 75.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12044",
    "data-name": "Path 12044",
    d: "M48.239,267.19a66.131,66.131,0,0,1-.155,7.2,63.874,63.874,0,0,1-.556,7.181,66.128,66.128,0,0,1,.155-7.2A66.267,66.267,0,0,1,48.239,267.19Z",
    transform: "translate(-47.478 -267.19)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7673",
    "data-name": "Group 7673",
    transform: "translate(12.112 78.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12045",
    "data-name": "Path 12045",
    d: "M45.291,271.22a12.926,12.926,0,0,1-.621,3.129,12.927,12.927,0,0,1-1,3.031,25.437,25.437,0,0,1,1.626-6.16Z",
    transform: "translate(-43.642 -271.219)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7674",
    "data-name": "Group 7674",
    transform: "translate(54.294 72.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12046",
    "data-name": "Path 12046",
    d: "M98.139,276.684a8.957,8.957,0,0,1-.8-1.9,37.578,37.578,0,0,1-1.315-4.8,37.032,37.032,0,0,1-.686-4.926A8.665,8.665,0,0,1,95.32,263a13.4,13.4,0,0,1,.294,2.034c.155,1.258.408,2.982.792,4.869s.841,3.578,1.193,4.787A12.668,12.668,0,0,1,98.139,276.684Z",
    transform: "translate(-95.276 -263)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7675",
    "data-name": "Group 7675",
    transform: "translate(34.255 6.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12047",
    "data-name": "Path 12047",
    d: "M87.766,183a5.007,5.007,0,0,1-.637.76c-.49.523-1.1,1.185-1.838,1.977-1.56,1.658-3.742,3.929-6.16,6.413-1.209,1.242-2.369,2.418-3.423,3.5-.27.261-.5.531-.809.784a1.265,1.265,0,0,1-.547.261.906.906,0,0,1-.6-.123,2.238,2.238,0,0,1-.678-.784q-.245-.392-.466-.76c-.555-.923-1.021-1.7-1.389-2.312a5.1,5.1,0,0,1-.466-.874,4.486,4.486,0,0,1,.6.792c.4.6.9,1.348,1.495,2.247.155.237.319.49.49.752a1.931,1.931,0,0,0,.588.662.639.639,0,0,0,.768-.131c.245-.2.5-.5.76-.76,1.054-1.087,2.2-2.279,3.407-3.521,2.418-2.492,4.632-4.73,6.241-6.339.768-.752,1.413-1.389,1.928-1.887A4.7,4.7,0,0,1,87.766,183Z",
    transform: "translate(-70.747 -182.998)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7676",
    "data-name": "Group 7676",
    transform: "translate(37.305 15.808)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12048",
    "data-name": "Path 12048",
    d: "M101.194,236.486Q89.908,215.042,77.5,194.21l-3.023,5.547c3.545,6.209,3.668,13.724,5.506,20.636a42.268,42.268,0,0,0,11.437,19.443c1.642,1.585,3.554,3.1,5.825,3.349s4.861-1.283,4.951-3.562A6.518,6.518,0,0,0,101.194,236.486Z",
    transform: "translate(-74.48 -194.21)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7677",
    "data-name": "Group 7677",
    transform: "translate(9.995 28.699)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12049",
    "data-name": "Path 12049",
    d: "M48.084,236.671l-7.034,7.156a6.523,6.523,0,0,0,6.576,3.848,10.227,10.227,0,0,0,6.9-3.954,24.609,24.609,0,0,0,3.75-7.222A104.73,104.73,0,0,0,64.1,209.99Q56.094,223.322,48.084,236.671Z",
    transform: "translate(-41.05 -209.99)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7678",
    "data-name": "Group 7678",
    transform: "translate(3.229 17.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12050",
    "data-name": "Path 12050",
    d: "M43.97,207.126a13.547,13.547,0,0,1-1.626-1.675c-.964-1.07-2.271-2.565-3.766-4.166a50.079,50.079,0,0,0-4.011-3.9c-1.087-.931-1.838-1.413-1.8-1.47.016-.025.212.074.564.278a12.511,12.511,0,0,1,1.413.972,35.282,35.282,0,0,1,4.125,3.848c1.5,1.609,2.778,3.137,3.693,4.256A14.275,14.275,0,0,1,43.97,207.126Z",
    transform: "translate(-32.768 -195.905)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7679",
    "data-name": "Group 7679",
    transform: "translate(57.664 11.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12051",
    "data-name": "Path 12051",
    d: "M107.545,188.61a20.569,20.569,0,0,1-1.462,1.748,36.6,36.6,0,0,0-5.759,9.272,20.375,20.375,0,0,1-.915,2.091,9.232,9.232,0,0,1,.654-2.2,29.276,29.276,0,0,1,2.459-4.959,28.523,28.523,0,0,1,3.358-4.4A9.89,9.89,0,0,1,107.545,188.61Z",
    transform: "translate(-99.401 -188.608)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7680",
    "data-name": "Group 7680",
    transform: "translate(5.362 9.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12052",
    "data-name": "Path 12052",
    d: "M52.323,186.248c.008.065-1.062.261-2.753.743a32.7,32.7,0,0,0-12.025,6.38c-1.348,1.127-2.116,1.912-2.165,1.863a3.3,3.3,0,0,1,.482-.6,18.373,18.373,0,0,1,1.495-1.479,28.367,28.367,0,0,1,5.678-3.962,28.78,28.78,0,0,1,6.462-2.475,19.818,19.818,0,0,1,2.059-.408A3.194,3.194,0,0,1,52.323,186.248Z",
    transform: "translate(-35.379 -186.239)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7681",
    "data-name": "Group 7681",
    transform: "translate(50.073 8.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12053",
    "data-name": "Path 12053",
    d: "M104.259,189.24a12.827,12.827,0,0,1-2.067-.686c-1.266-.457-3.006-1.07-4.959-1.683S93.5,185.76,92.2,185.408a13.914,13.914,0,0,1-2.091-.621,10.784,10.784,0,0,1,2.157.343c1.315.278,3.121.735,5.089,1.356s3.7,1.283,4.942,1.805A10.008,10.008,0,0,1,104.259,189.24Z",
    transform: "translate(-90.11 -184.777)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7682",
    "data-name": "Group 7682",
    transform: "translate(58.389 23.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12054",
    "data-name": "Path 12054",
    d: "M113.353,203.351a54.94,54.94,0,0,1-6.519.686,52.418,52.418,0,0,1-6.544.286,54.93,54.93,0,0,1,6.519-.686A54.323,54.323,0,0,1,113.353,203.351Z",
    transform: "translate(-100.29 -203.313)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7683",
    "data-name": "Group 7683",
    transform: "translate(64.557 35.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12055",
    "data-name": "Path 12055",
    d: "M117.1,217.8a3.725,3.725,0,0,1-1.315.408,20.077,20.077,0,0,1-3.292.368c-1.291.049-2.451.041-3.292.041a5.065,5.065,0,0,1-1.364-.065,21.745,21.745,0,0,1,4.64-.368C115.045,218.115,117.071,217.7,117.1,217.8Z",
    transform: "translate(-107.84 -217.782)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7684",
    "data-name": "Group 7684",
    transform: "translate(0.739 28.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12056",
    "data-name": "Path 12056",
    d: "M42.824,209.636a6.992,6.992,0,0,1-1.887.409,34.153,34.153,0,0,1-4.648.286c-1.822,0-3.456-.073-4.648-.123a10.423,10.423,0,0,1-1.92-.139,8.937,8.937,0,0,1,1.928-.139c1.193-.024,2.835,0,4.64,0s3.439-.073,4.616-.163A14.449,14.449,0,0,1,42.824,209.636Z",
    transform: "translate(-29.72 -209.619)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7692",
    "data-name": "Group 7692",
    transform: "translate(4.072 37.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7688",
    "data-name": "Group 7688",
    transform: "translate(29.203 1.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12057",
    "data-name": "Path 12057",
    d: "M70.349,163.938s-1.07,9.917-.515,10.914,5.89,7.066,5.89,7.066l8.03-.294,5.057-13.912-1.136-5.874s-1.1-.188-1.4,1.274l-.915-4.2s-2.116-.939-2.083.948.114,3.84.114,3.84l-1.25,5.188.539-7.2L81.3,157.353s-1.748-.637-2.01,1.805a28.878,28.878,0,0,0-.1,4.55L78,168.1l.172-8.039s-.5-2.729-1.879-1.969-2.557,12.809-2.557,12.809l-.76,1.52.294-3.488C73.282,168.921,73.42,162.247,70.349,163.938Z",
    transform: "translate(-69.571 -157.07)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7686",
    "data-name": "Group 7686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12058",
    "data-name": "Path 12058",
    d: "M70.326,163.891a.982.982,0,0,1,.155-.09,1.822,1.822,0,0,1,.5-.188,1.256,1.256,0,0,1,.866.114,1.933,1.933,0,0,1,.784.907,9.115,9.115,0,0,1,.694,3.251c.016.327.033.662.025,1.021-.025.351-.057.711-.082,1.087-.057.743-.123,1.536-.188,2.377l-.2-.057c.229-.466.49-.989.76-1.528l-.008.041c.221-2.214.5-4.705.939-7.41a31.2,31.2,0,0,1,.915-4.207,3.851,3.851,0,0,1,.482-1.062.964.964,0,0,1,1.217-.3,1.888,1.888,0,0,1,.792.964,5.322,5.322,0,0,1,.368,1.16V160c-.049,2.549-.106,5.237-.163,8.039l-.351-.049c.368-1.372.768-2.867,1.176-4.4l-.008.065a28.247,28.247,0,0,1,.024-3.807,5,5,0,0,1,.408-1.985,1.535,1.535,0,0,1,.809-.743,1.673,1.673,0,0,1,1.111-.016l.09.025.033.1c.441,1.364.915,2.843,1.389,4.338l.008.033v.041c-.172,2.3-.351,4.73-.539,7.2l-.392-.065c.237-1,.5-2.083.76-3.161.163-.678.327-1.356.49-2.026l-.008.057c-.025-.923-.057-1.846-.082-2.761,0-.466-.049-.89-.016-1.4a1.283,1.283,0,0,1,.31-.727,1.087,1.087,0,0,1,.735-.327,1.509,1.509,0,0,1,1.34.645,1.734,1.734,0,0,1,.286.686l.139.654c.188.866.376,1.732.564,2.59h-.384a2.032,2.032,0,0,1,.507-1.038,1.372,1.372,0,0,1,1.119-.392l.131.016.024.139q.576,3,1.127,5.882l.008.049-.016.049c-1.822,4.983-3.529,9.648-5.081,13.9l-.041.106h-.114c-2.876.1-5.547.188-8.03.278h-.074l-.041-.049c-2.042-2.353-3.889-4.477-5.408-6.437a3.284,3.284,0,0,1-.506-.792,1.646,1.646,0,0,1-.082-.466c-.016-.147-.025-.294-.033-.441-.024-.58,0-1.135.016-1.667.041-1.062.114-2.026.18-2.892.139-1.74.286-3.08.384-3.995.049-.441.1-.784.123-1.038.041-.212.065-.343.065-.335a2.366,2.366,0,0,1-.016.359c-.016.253-.049.6-.082,1.037-.074.915-.188,2.263-.31,3.995-.057.866-.114,1.838-.147,2.892-.016.531-.033,1.078,0,1.65a2.42,2.42,0,0,0,.033.425,2.02,2.02,0,0,0,.074.408,2.992,2.992,0,0,0,.482.735c1.528,1.928,3.4,4.052,5.449,6.388l-.114-.049,8.03-.319-.147.1c1.544-4.256,3.227-8.929,5.032-13.912l-.008.1q-.551-2.867-1.144-5.874l.155.155a1,1,0,0,0-.784.278,1.618,1.618,0,0,0-.392.833l-.18.931-.2-.931c-.188-.858-.376-1.724-.564-2.59l-.139-.654a1.251,1.251,0,0,0-.221-.547,1.108,1.108,0,0,0-.98-.482.712.712,0,0,0-.686.711c-.024.4.016.89.016,1.34.025.915.057,1.83.082,2.753v.033l-.008.025c-.163.67-.327,1.348-.49,2.026-.261,1.087-.523,2.157-.76,3.162l-.392-.065c.188-2.467.368-4.9.539-7.2l.008.074c-.474-1.5-.948-2.974-1.381-4.338l.114.123a1.185,1.185,0,0,0-1.454.58,4.746,4.746,0,0,0-.359,1.83,27.547,27.547,0,0,0-.033,3.758v.033l-.008.033c-.408,1.528-.817,3.023-1.185,4.4l-.392,1.438.033-1.487c.065-2.8.131-5.49.188-8.039v.033a4.949,4.949,0,0,0-.343-1.087,1.586,1.586,0,0,0-.645-.809.637.637,0,0,0-.441-.049,1.811,1.811,0,0,0-.221.1.7.7,0,0,0-.155.155,3.764,3.764,0,0,0-.441.972,29.723,29.723,0,0,0-.923,4.15c-.449,2.7-.752,5.179-.988,7.385v.024l-.008.016c-.27.531-.531,1.054-.768,1.52l-.253.506.049-.564c.074-.833.147-1.626.212-2.369q.049-.564.1-1.078c.008-.343,0-.678-.016-1a8.975,8.975,0,0,0-.629-3.211,1.906,1.906,0,0,0-.727-.882,1.152,1.152,0,0,0-.809-.131A4.074,4.074,0,0,0,70.326,163.891Z",
    transform: "translate(-69.547 -157.024)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7687",
    "data-name": "Group 7687",
    transform: "translate(15.869 5.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12059",
    "data-name": "Path 12059",
    d: "M88.987,172.24a18.83,18.83,0,0,1,.988-3.6l-.008.074c-.008-.155-.016-.31-.033-.474a22.5,22.5,0,0,1-.049-4.207,22.3,22.3,0,0,1,.441,4.183c.008.163.016.319.025.474v.041l-.008.033A18.927,18.927,0,0,1,88.987,172.24Z",
    transform: "translate(-88.973 -164.03)",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12060",
    "data-name": "Path 12060",
    d: "M33.8,218.139s.931,11.143,5.49,13.994,10.7,4.648,16-8.545c2.5-6.225,15.121-39.09,15.121-39.09L59.631,180.34,38.742,214.087Z",
    transform: "translate(-33.8 -159.566)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12061",
    "data-name": "Path 12061",
    d: "M81.715,179.42l23.675,33.739h0s7.254,15.383-2.573,20.031c-8.088,3.823-14.133-4.322-16.592-11.4C83.7,214.532,72.99,185.727,72.99,185.727Z",
    transform: "translate(-40.975 -159.397)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7691",
    "data-name": "Group 7691",
    transform: "translate(21.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12062",
    "data-name": "Path 12062",
    d: "M64.062,156.89s-.792,8.676-.792,9.811,1.756,9.027,1.756,9.027l9.2,8.259,9.117-14.394L85.18,163.9s-.874-.7-1.838.441l1.225-4.117s-1.405-1.838-2.279-.172-1.756,3.415-1.756,3.415l-3.594,3.946,3.946-6.045.874-4.469s-1.225-1.405-2.631.613a27.993,27.993,0,0,0-2.279,3.946l-3.153,3.284,4.027-6.96s.874-2.631-.7-2.631-8.414,9.991-8.414,9.991L67.2,166.1l-.7-3.611C66.521,162.486,67.567,156.89,64.062,156.89Z",
    transform: "translate(-60.827 -154.954)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7689",
    "data-name": "Group 7689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12063",
    "data-name": "Path 12063",
    d: "M67.567,199.825a1.466,1.466,0,0,1,.09-.278q.11-.294.294-.809c.27-.727.662-1.773,1.168-3.129,1.038-2.737,2.549-6.715,4.444-11.707l.008-.008.008-.008c2.541-4.036,5.62-8.921,9.076-14.419l-.016.041c.572-1.789,1.193-3.717,1.83-5.7l.057.2a.988.988,0,0,0-.809-.139,1.662,1.662,0,0,0-.784.555l-.555.662.245-.833c.384-1.283.8-2.688,1.225-4.117l.033.163A1.987,1.987,0,0,0,82.7,159.5a.684.684,0,0,0-.572.278,3.3,3.3,0,0,0-.4.678c-.515,1-1.037,2.026-1.56,3.055l-.016.024-.016.016c-1.127,1.242-2.353,2.582-3.586,3.946l-.31-.237c1.25-1.92,2.581-3.97,3.938-6.045l-.025.073c.278-1.413.572-2.933.874-4.469l.049.172a1.2,1.2,0,0,0-1.111-.376,1.921,1.921,0,0,0-1.062.792,25.871,25.871,0,0,0-2.4,4.1l-.025.008-.025.025L73.3,164.819,72.166,166l.817-1.413q2.059-3.554,4.036-6.96l-.016.033a3.363,3.363,0,0,0,.131-1.969.631.631,0,0,0-.662-.4,2.016,2.016,0,0,0-.792.474,25.616,25.616,0,0,0-2.761,3.047c-1.7,2.132-3.243,4.281-4.7,6.372l-.016.024-.025.016c-.482.327-.948.645-1.405.964l-.221.147-.049-.261c-.237-1.234-.466-2.434-.694-3.611l-.008-.033.008-.033a8.664,8.664,0,0,0-.057-3.5,2.784,2.784,0,0,0-.784-1.405,2.308,2.308,0,0,0-1.446-.506l.155-.139q-.27,2.978-.506,5.678c-.074.9-.147,1.773-.212,2.622-.025.425-.057.841-.082,1.25a5.275,5.275,0,0,0,.1,1.185c.531,3.145,1.136,5.849,1.6,8.079l.008.033-.016.033c-1.381,2.2-2.443,3.889-3.17,5.04-.359.555-.629.988-.825,1.291-.188.286-.294.425-.294.425s.082-.155.253-.449c.188-.31.449-.743.784-1.315.711-1.168,1.748-2.876,3.1-5.089l-.008.065c-.49-2.23-1.119-4.918-1.675-8.079a6.079,6.079,0,0,1-.114-1.234c.025-.417.049-.833.074-1.258q.1-1.274.2-2.622c.155-1.8.31-3.693.482-5.678l.016-.147.139.008a2.646,2.646,0,0,1,1.658.58,3.182,3.182,0,0,1,.882,1.56,8.81,8.81,0,0,1,.074,3.643V162.4c.229,1.176.466,2.369.711,3.6l-.27-.106c.457-.319.923-.637,1.4-.964l-.049.049c1.454-2.108,3-4.256,4.7-6.4a25.588,25.588,0,0,1,2.81-3.1,2.128,2.128,0,0,1,1.021-.564,1.248,1.248,0,0,1,.613.139,1.049,1.049,0,0,1,.417.49,2.443,2.443,0,0,1,.114,1.152,5.55,5.55,0,0,1-.229,1.095l-.008.016-.008.016c-1.315,2.271-2.655,4.6-4.027,6.96l-.31-.237c1.037-1.087,2.091-2.173,3.153-3.284l-.041.057a27.027,27.027,0,0,1,2.451-4.183,2.35,2.35,0,0,1,1.3-.931,1.584,1.584,0,0,1,1.487.506l.065.065-.016.1c-.3,1.536-.6,3.055-.874,4.469l-.008.041-.025.033c-1.356,2.075-2.7,4.125-3.946,6.045l-.31-.237c1.242-1.356,2.467-2.7,3.594-3.938l-.033.041c.531-1.037,1.062-2.059,1.569-3.063a3.2,3.2,0,0,1,.457-.752,1.063,1.063,0,0,1,.874-.4,2.285,2.285,0,0,1,1.446.939l.057.065-.033.1c-.425,1.43-.85,2.835-1.234,4.117l-.31-.163a2.028,2.028,0,0,1,.964-.67,1.336,1.336,0,0,1,1.127.2l.1.074-.041.123c-.645,1.985-1.266,3.9-1.846,5.694l-.008.025-.008.016c-3.488,5.473-6.584,10.35-9.15,14.37l.008-.025c-1.944,4.975-3.488,8.937-4.558,11.666-.531,1.34-.948,2.377-1.234,3.1-.139.335-.245.6-.327.792A.931.931,0,0,1,67.567,199.825Z",
    transform: "translate(-60.28 -154.91)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7690",
    "data-name": "Group 7690",
    transform: "translate(18.915 9.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12064",
    "data-name": "Path 12064",
    d: "M87.148,165.93a13.1,13.1,0,0,1-.7,2.925l-.008.033-.024.033c-.147.18-.294.351-.441.539a16.714,16.714,0,0,1-2.532,2.7,17.761,17.761,0,0,1,2.222-2.965c.155-.18.3-.359.449-.531l-.041.065A13.914,13.914,0,0,1,87.148,165.93Z",
    transform: "translate(-83.434 -165.93)",
    fill: "#eb996e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7714",
    "data-name": "Group 7714",
    transform: "translate(73.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7710",
    "data-name": "Group 7710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7703",
    "data-name": "Group 7703",
    transform: "translate(0.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7702",
    "data-name": "Group 7702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7701",
    "data-name": "Group 7701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7700",
    "data-name": "Group 7700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7699",
    "data-name": "Group 7699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7698",
    "data-name": "Group 7698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7697",
    "data-name": "Group 7697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7694",
    "data-name": "Group 7694",
    transform: "translate(0.449 0.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12065",
    "data-name": "Path 12065",
    d: "M142.684,113.611l-8.7-9.011-2.165,14.255-11.658-.4,7.3,9.583-7.336,9.632,12.148-2.4,1.765,12.229,9.819-7.442,12.393,6.486-2.712-12.515,14.059-2.214-10.939-6.454,6.38-11-10.93,4.273-1.332-13.553Z",
    transform: "translate(-120.12 -104.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7696",
    "data-name": "Group 7696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7695",
    "data-name": "Group 7695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12066",
    "data-name": "Path 12066",
    d: "M142.583,113.559s.18-.2.531-.588.874-.939,1.552-1.667c1.372-1.462,3.374-3.594,5.939-6.339l.139-.147.016.2c.368,3.684.833,8.259,1.364,13.553l-.18-.106c3.276-1.291,6.96-2.737,10.914-4.3l.4-.155-.221.376c-1.969,3.4-4.109,7.107-6.356,11l-.057-.229,10.939,6.446.433.253-.5.082c-4.485.711-9.2,1.454-14.059,2.222l.155-.229c.866,3.987,1.781,8.21,2.72,12.515l.09.408-.368-.2c-3.431-1.8-7.058-3.693-10.734-5.62-.556-.286-1.1-.58-1.658-.866l.212-.016q-5,3.786-9.828,7.442l-.261.2-.049-.327c-.6-4.166-1.185-8.251-1.748-12.229l.221.155q-6.274,1.225-12.156,2.385l-.466.09.294-.384q3.823-5.012,7.352-9.623v.2q-3.86-5.073-7.279-9.591l-.2-.261.327.008c4.232.147,8.1.286,11.658.417l-.139.114c.866-5.6,1.6-10.375,2.2-14.247l.033-.188.131.139c2.794,2.925,4.951,5.179,6.413,6.715.727.76,1.274,1.348,1.658,1.748.368.425.564.637.564.637s-.188-.18-.564-.564-.939-.956-1.675-1.7c-1.487-1.528-3.684-3.766-6.527-6.682l.155-.049c-.58,3.872-1.291,8.643-2.124,14.255l-.016.114h-.114c-3.554-.114-7.426-.237-11.658-.376l.131-.245q3.443,4.5,7.3,9.566l.082.106-.082.106q-3.517,4.62-7.328,9.64l-.18-.286q5.882-1.164,12.156-2.4l.2-.041.025.2q.858,5.968,1.765,12.229l-.31-.131q4.828-3.652,9.828-7.442l.1-.074.114.057c.547.286,1.1.58,1.658.866,3.676,1.928,7.3,3.823,10.734,5.62l-.278.212c-.931-4.305-1.846-8.529-2.7-12.515l-.041-.2.2-.033c4.861-.76,9.574-1.5,14.059-2.206l-.065.335c-3.791-2.247-7.45-4.4-10.93-6.462l-.147-.082.082-.147c2.263-3.889,4.411-7.589,6.388-10.988l.188.221c-3.962,1.544-7.655,2.974-10.93,4.248l-.163.065-.016-.172c-.507-5.294-.939-9.877-1.291-13.561l.155.057c-2.622,2.729-4.656,4.853-6.053,6.307-.686.711-1.209,1.25-1.569,1.626Z",
    transform: "translate(-119.57 -104.32)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7709",
    "data-name": "Group 7709",
    transform: "translate(0 40.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7708",
    "data-name": "Group 7708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7707",
    "data-name": "Group 7707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7704",
    "data-name": "Group 7704",
    transform: "translate(0.196 0.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12067",
    "data-name": "Path 12067",
    d: "M124.606,156.528a2.6,2.6,0,1,1-2.6-2.6A2.594,2.594,0,0,1,124.606,156.528Z",
    transform: "translate(-119.41 -153.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7706",
    "data-name": "Group 7706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7705",
    "data-name": "Group 7705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12068",
    "data-name": "Path 12068",
    d: "M124.562,156.491c-.033,0-.041-.229-.155-.613a2.609,2.609,0,0,0-.956-1.34,2.468,2.468,0,0,0-2.312-.319,2.424,2.424,0,0,0,0,4.542,2.472,2.472,0,0,0,2.312-.319,2.609,2.609,0,0,0,.956-1.34c.123-.384.123-.613.155-.613a1.308,1.308,0,0,1-.008.654,2.565,2.565,0,0,1-.931,1.519,2.723,2.723,0,0,1-2.606.433,2.762,2.762,0,0,1,0-5.212,2.732,2.732,0,0,1,2.606.433,2.565,2.565,0,0,1,.931,1.52C124.635,156.262,124.586,156.491,124.562,156.491Z",
    transform: "translate(-119.17 -153.727)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7713",
    "data-name": "Group 7713",
    transform: "translate(20.482 13.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7711",
    "data-name": "Group 7711"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12069",
    "data-name": "Path 12069",
    d: "M148.382,122.21l-.523,8.308a1.347,1.347,0,0,1-1.266,1.258h0a1.35,1.35,0,0,1-1.421-1.2l-.923-8.349a1.062,1.062,0,0,1,1.07-1.176l2.026.025A1.076,1.076,0,0,1,148.382,122.21Z",
    transform: "translate(-144.241 -121.05)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7712",
    "data-name": "Group 7712",
    transform: "translate(0.043 12.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12070",
    "data-name": "Path 12070",
    d: "M144.4,139.311a2.028,2.028,0,1,0,1.283-2.565A2.023,2.023,0,0,0,144.4,139.311Z",
    transform: "translate(-144.294 -136.64)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Device",
    transform: "translate(692.126 146.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7722",
    "data-name": "Group 7722",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7721",
    "data-name": "Group 7721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7720",
    "data-name": "Group 7720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7719",
    "data-name": "Group 7719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7716",
    "data-name": "Group 7716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7715",
    "data-name": "Group 7715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12071",
    "data-name": "Path 12071",
    d: "M309.64,397.205l-102.794-.474a22.389,22.389,0,0,1-22.286-22.49l1.087-257.708a22.387,22.387,0,0,1,22.5-22.294l102.794.474a22.389,22.389,0,0,1,22.286,22.49l-1.087,257.708A22.4,22.4,0,0,1,309.64,397.205Z",
    transform: "translate(-184.56 -94.24)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7718",
    "data-name": "Group 7718",
    transform: "translate(5.98 7.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7717",
    "data-name": "Group 7717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12072",
    "data-name": "Path 12072",
    d: "M311.282,103.576l-19.933-.09a4.955,4.955,0,0,0-4.861,5.04l-.016,3.619a4.955,4.955,0,0,1-4.861,5.04l-38.845-.18a4.957,4.957,0,0,1-4.82-5.081l.016-3.619a4.957,4.957,0,0,0-4.82-5.081l-7.009-.033-17.441-.082a15.679,15.679,0,0,0-15.75,15.62L191.88,370.27a15.682,15.682,0,0,0,15.611,15.75l102.59.474a15.677,15.677,0,0,0,15.75-15.611l1.062-251.54A15.686,15.686,0,0,0,311.282,103.576Z",
    transform: "translate(-191.88 -103.11)",
    fill: "#fafafa"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7723",
    "data-name": "Group 7723",
    transform: "translate(18.357 30.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12073",
    "data-name": "Path 12073",
    d: "M209,135.526a.415.415,0,0,1-.294-.123l-1.56-1.634a.428.428,0,0,1-.114-.294.416.416,0,0,1,.122-.286l1.56-1.495a.41.41,0,1,1,.564.6L208.01,133.5l1.283,1.34a.412.412,0,0,1-.016.58A.419.419,0,0,1,209,135.526Z",
    transform: "translate(-207.03 -131.584)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7726",
    "data-name": "Group 7726",
    transform: "translate(19.223 247.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7724",
    "data-name": "Group 7724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12074",
    "data-name": "Path 12074",
    d: "M306.064,425.32H221.259a13.172,13.172,0,0,1-13.169-13.169V409.8a13.172,13.172,0,0,1,13.169-13.169h84.813A13.172,13.172,0,0,1,319.241,409.8v2.353A13.174,13.174,0,0,1,306.064,425.32Z",
    transform: "translate(-208.09 -396.63)",
    fill: "#508c76"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7725",
    "data-name": "Group 7725",
    transform: "translate(42.349 10.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12075",
    "data-name": "Path 12075",
    d: "M259.93,410.11h2.581a3.177,3.177,0,1,1,0,6.339H259.93Zm2.549,5.768a2.6,2.6,0,1,0,0-5.179H260.6v5.187h1.879Z",
    transform: "translate(-259.93 -410.053)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12076",
    "data-name": "Path 12076",
    d: "M268.4,413.267a3.331,3.331,0,1,1,3.333,3.227A3.194,3.194,0,0,1,268.4,413.267Zm6,0a2.663,2.663,0,1,0-2.655,2.631A2.575,2.575,0,0,0,274.4,413.267Z",
    transform: "translate(-261.481 -410.04)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12077",
    "data-name": "Path 12077",
    d: "M283.692,410.11v6.348h-.555l-4.077-5.147v5.147h-.67V410.11h.556l4.085,5.147V410.11Z",
    transform: "translate(-263.31 -410.053)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12078",
    "data-name": "Path 12078",
    d: "M291.895,415.878v.58H287.41V410.11h4.346v.58H288.08v2.255h3.284v.572H288.08v2.353h3.815Z",
    transform: "translate(-264.961 -410.053)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7733",
    "data-name": "Group 7733",
    transform: "translate(118.406 29.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7728",
    "data-name": "Group 7728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7727",
    "data-name": "Group 7727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12079",
    "data-name": "Path 12079",
    d: "M341.035,131a78.421,78.421,0,0,1-11.535,0,39.825,39.825,0,0,1,5.768-.212A38.56,38.56,0,0,1,341.035,131Z",
    transform: "translate(-329.5 -130.79)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7730",
    "data-name": "Group 7730",
    transform: "translate(0 2.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7729",
    "data-name": "Group 7729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12080",
    "data-name": "Path 12080",
    d: "M341.035,133.942a78.41,78.41,0,0,1-11.535,0,78.416,78.416,0,0,1,11.535,0Z",
    transform: "translate(-329.5 -133.73)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7732",
    "data-name": "Group 7732",
    transform: "translate(0 4.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7731",
    "data-name": "Group 7731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12081",
    "data-name": "Path 12081",
    d: "M341.035,136.882a78.41,78.41,0,0,1-11.535,0,78.421,78.421,0,0,1,11.535,0Z",
    transform: "translate(-329.5 -136.67)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "Payment_Denied",
    "data-name": "Payment Denied",
    transform: "translate(37.876 155.446)",
    fontSize: 9,
    fontFamily: "MyriadPro-Semibold, Myriad Pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Payment Denied")), /*#__PURE__*/React.createElement("text", {
    id: "Transaction_Failed",
    "data-name": "Transaction Failed",
    transform: "translate(47.868 172.889)",
    fontSize: 5,
    fontFamily: "MyriadPro-Regular, Myriad Pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Transaction Failed")), /*#__PURE__*/React.createElement("g", {
    id: "Group_7735",
    "data-name": "Group 7735",
    transform: "translate(42.746 69.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12082",
    "data-name": "Path 12082",
    d: "M239.816,219.659l19.165-33.192a10.644,10.644,0,0,1,18.438,0l19.165,33.192a10.641,10.641,0,0,1-9.215,15.963H249.04A10.638,10.638,0,0,1,239.816,219.659Z",
    transform: "translate(-237.157 -179.931)",
    fill: "#de5d5d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7734",
    "data-name": "Group 7734",
    transform: "translate(27.641 12.752)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_359",
    "data-name": "Ellipse 359",
    cx: 3.398,
    cy: 3.398,
    r: 3.398,
    transform: "translate(0 27.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12083",
    "data-name": "Path 12083",
    d: "M274.118,216.1h0a3.4,3.4,0,0,1-3.4-3.4V198.668a3.4,3.4,0,0,1,3.4-3.4h0a3.4,3.4,0,0,1,3.4,3.4V212.7A3.4,3.4,0,0,1,274.118,216.1Z",
    transform: "translate(-270.72 -195.27)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12084",
    "data-name": "Path 12084",
    d: "M287.089,236.567H272.956a1.209,1.209,0,1,1,0-2.418h14.133a9.427,9.427,0,0,0,8.169-14.141l-19.165-33.192a9.436,9.436,0,0,0-16.339,0L240.59,220.008a9.427,9.427,0,0,0,8.169,14.141H262.41a1.209,1.209,0,1,1,0,2.418H248.759a11.858,11.858,0,0,1-10.269-17.784l19.165-33.192a11.855,11.855,0,0,1,20.538,0l19.165,33.192a11.858,11.858,0,0,1-10.269,17.784Z",
    transform: "translate(-236.885 -179.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12085",
    "data-name": "Path 12085",
    d: "M274.609,248.776a1.247,1.247,0,0,1-.858-.351,1.212,1.212,0,0,1-.351-.858,1.247,1.247,0,0,1,.351-.858,1.213,1.213,0,1,1,1.716,1.716A1.247,1.247,0,0,1,274.609,248.776Z",
    transform: "translate(-243.57 -191.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12086",
    "data-name": "Path 12086",
    d: "M273.847,236.225a4.607,4.607,0,1,1,4.607-4.607A4.613,4.613,0,0,1,273.847,236.225Zm0-6.789a2.181,2.181,0,1,0,2.181,2.181A2.186,2.186,0,0,0,273.847,229.436Z",
    transform: "translate(-242.808 -188.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12087",
    "data-name": "Path 12087",
    d: "M273.847,217.05a4.613,4.613,0,0,1-4.607-4.607V198.407a4.607,4.607,0,0,1,9.215,0v14.035A4.613,4.613,0,0,1,273.847,217.05Zm0-20.823a2.186,2.186,0,0,0-2.181,2.181v14.035a2.181,2.181,0,1,0,4.362,0V198.407A2.186,2.186,0,0,0,273.847,196.226Z",
    transform: "translate(-242.808 -182.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12088",
    "data-name": "Path 12088",
    d: "M259.519,209.126a1.247,1.247,0,0,1-.858-.351,1.211,1.211,0,0,1-.351-.858,1.247,1.247,0,0,1,.351-.858,1.213,1.213,0,1,1,1.716,1.716A1.232,1.232,0,0,1,259.519,209.126Z",
    transform: "translate(-240.807 -184.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12089",
    "data-name": "Path 12089",
    d: "M247.878,226.724a1.182,1.182,0,0,1-.6-.163,1.215,1.215,0,0,1-.449-1.658l6.936-12.1a1.215,1.215,0,0,1,2.108,1.209l-6.936,12.1A1.224,1.224,0,0,1,247.878,226.724Z",
    transform: "translate(-238.675 -185.616)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(866.662 394.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7751",
    "data-name": "Group 7751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7737",
    "data-name": "Group 7737",
    transform: "translate(13.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7736",
    "data-name": "Group 7736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12090",
    "data-name": "Path 12090",
    d: "M420.973,397.8a10.168,10.168,0,0,1,5.253,5.947,17.781,17.781,0,0,1,.694,8.055c-.6,5.228-3.562,10.506-6.764,14.688-4.4-3.84-5.416-10.547-5.719-13.978-.466-5.424,1.969-15.522,6.535-14.713",
    transform: "translate(-414.381 -397.754)",
    fill: "#4d5a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7739",
    "data-name": "Group 7739",
    transform: "translate(23.91 26.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7738",
    "data-name": "Group 7738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12091",
    "data-name": "Path 12091",
    d: "M427.676,441.057a8.64,8.64,0,0,1,2.794-8.218,11.511,11.511,0,0,1,8.463-2.647,4.839,4.839,0,0,1,3.717,1.667,3.688,3.688,0,0,1,.057,3.75,7.422,7.422,0,0,1-2.778,2.729c-3.807,2.394-7.94,4.011-12.254,2.72",
    transform: "translate(-427.478 -430.156)",
    fill: "#4d5a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7742",
    "data-name": "Group 7742",
    transform: "translate(18.457 31.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7741",
    "data-name": "Group 7741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7740",
    "data-name": "Group 7740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12092",
    "data-name": "Path 12092",
    d: "M420.809,458.244a6.223,6.223,0,0,1,.155-1.07c.139-.752.319-1.732.531-2.9a30.381,30.381,0,0,1,3-9.272,18.583,18.583,0,0,1,6.658-7.075,12.7,12.7,0,0,1,2.712-1.2,6.308,6.308,0,0,1,.784-.2.9.9,0,0,1,.278-.041,19.653,19.653,0,0,0-3.635,1.667,19.169,19.169,0,0,0-6.462,7.026,32.529,32.529,0,0,0-3.063,9.141c-.27,1.217-.482,2.206-.654,2.884A6.21,6.21,0,0,1,420.809,458.244Z",
    transform: "translate(-420.803 -436.487)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7745",
    "data-name": "Group 7745",
    transform: "translate(18.406 7.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7744",
    "data-name": "Group 7744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7743",
    "data-name": "Group 7743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12093",
    "data-name": "Path 12093",
    d: "M420.961,407.42a1.968,1.968,0,0,1,.057.466c.024.351.049.793.082,1.348.065,1.168.131,2.867.2,4.959.139,4.191.245,9.983.212,16.379s-.188,12.189-.359,16.379c-.082,2.091-.172,3.791-.245,4.959-.041.556-.065,1-.09,1.348-.024.31.016,0,0,0,.057-.466-.074.3-.074,0,.008-.351.008-.792.016-1.348.033-1.217.074-2.9.123-4.959.106-4.191.221-9.975.245-16.371s-.041-12.18-.106-16.371c-.033-2.059-.057-3.742-.082-4.959,0-.555-.008-1-.008-1.348A4.4,4.4,0,0,1,420.961,407.42Z",
    transform: "translate(-420.74 -407.42)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7747",
    "data-name": "Group 7747",
    transform: "translate(0 25.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7746",
    "data-name": "Group 7746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12094",
    "data-name": "Path 12094",
    d: "M414.7,443.908A20.227,20.227,0,0,0,403.659,429.1c-1.47-.7-3.39-1.168-4.6-.074s-.939,3.064-.351,4.583A17.283,17.283,0,0,0,414.6,444.333",
    transform: "translate(-398.21 -428.372)",
    fill: "#4d5a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7750",
    "data-name": "Group 7750",
    transform: "translate(6.159 30.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7749",
    "data-name": "Group 7749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7748",
    "data-name": "Group 7748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12095",
    "data-name": "Path 12095",
    d: "M405.75,435.329a5.17,5.17,0,0,1,.931.408,9.973,9.973,0,0,1,1.054.564c.392.245.874.49,1.348.841a18.506,18.506,0,0,1,1.536,1.16,19.084,19.084,0,0,1,1.634,1.487,22.709,22.709,0,0,1,3.112,3.995,22.3,22.3,0,0,1,2.051,4.632,18.467,18.467,0,0,1,.515,2.148,16.222,16.222,0,0,1,.261,1.9,13.953,13.953,0,0,1,.074,1.585,8.931,8.931,0,0,1-.033,1.193,5.443,5.443,0,0,1-.114,1.013c-.09,0,.065-1.454-.2-3.766a17.65,17.65,0,0,0-.3-1.871,20.052,20.052,0,0,0-.539-2.108,22.712,22.712,0,0,0-2.042-4.542,23.352,23.352,0,0,0-3.031-3.946,18.8,18.8,0,0,0-1.585-1.487,18.611,18.611,0,0,0-1.487-1.176C407.041,436.007,405.709,435.4,405.75,435.329Z",
    transform: "translate(-405.749 -435.327)",
    fill: "#263238"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureTransaction);
export default __webpack_public_path__ + "static/media/failure-transaction.b4621b014e1376a8cdf1695c9c96c83f.svg";
export { ForwardRef as ReactComponent };